import notify from 'devextreme/ui/notify';
import { TaskDataService } from './../../shared/services/task-data.service';
import {
  Component,
  HostListener,
  ViewChild,
  OnInit,
  ChangeDetectorRef,
  DestroyRef,
} from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { DxDrawerTypes } from 'devextreme-angular/ui/drawer';
import { DxoPagerComponent } from 'devextreme-angular/ui/nested';
import { DxListComponent } from 'devextreme-angular/ui/list';
import { ProfileDataService } from '../../shared/services/profile-data.service';
import {
  IButtonConfig,
  IGridColumn,
  ITaskResponse,
  ITaskTag,
  TaskCommentPost,
} from '../../modules/tasks/model/types';
import { ActivatedRoute, Router } from '@angular/router';
import { assignTaskToMe } from '../../types/task-resources';
import { DataGridComponent } from '../../shared/components/data-grid/data-grid.component';
import {
  DatePanelItem,
  DatePanelItems,
  datePanelItems,
  getDialogYesNoOptions,
  getNotificationTimeout,
} from '../../types/resource';
import { LoggingService } from '../../framework/logging/logging.service';
import { SeverityLevel } from '../../framework/logging/severity-level.model';
import { FilterDescriptor, LoadOptions } from 'devextreme/data';
import { HttpParams } from '@angular/common/http';
import { BehaviorSubject, lastValueFrom, skipWhile, take } from 'rxjs';
import { DxRadioGroupTypes } from 'devextreme-angular/ui/radio-group';
import { Message } from 'devextreme/ui/chat';
import { custom } from 'devextreme/ui/dialog';
import { environment } from '../../../environments/environment';
import FileSaver from 'file-saver';
import { Workbook } from 'exceljs';
import { locale } from 'devextreme/localization';
import { SignalRService } from '../../shared/services/signal-r.service';
import { FilterStateService } from '../../shared/services/filter-state.service';
import { FeatureFlagsService } from '../../shared/services/feature-flags.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UtilitiesService } from '../../shared/components/framework/services/utilities.service';
import { buildSharePointTaskUrl } from '../../shared/utils/safe-navigation.util';

@Component({
  standalone: false,
  templateUrl: 'tasks.component.html',
  selector: 'task-detail',
  styleUrls: ['./tasks.component.css'],
})
export class TasksComponent implements OnInit {
  @ViewChild('dataGrid', { static: false }) dataGridTasks: DataGridComponent;
  @ViewChild('cardList') private cardListEl?: DxListComponent;

  /** True when viewport is < 1024px — card view replaces the grid table. */
  get isCardView(): boolean {
    return typeof window !== 'undefined' && window.innerWidth < 1024;
  }

  /** Region-aware date display format for the due-date column (dd/MM/yyyy for EU). */
  get dateDisplayFormat(): string {
    return locale() === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
  }

  /** Region-aware grid search placeholder — EU deployments label the reference column "Deal Name". */
  get searchPlaceholderText(): string {
    const referenceColumnLabel = this.featureFlagsService.isEu() ? 'Deal Name' : 'Reference Name';
    return `Search by Task Id, ${referenceColumnLabel} or Detail... `;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    // Triggers Angular change detection so isCardView re-evaluates and
    // the *ngIf on the card list section updates immediately on resize.
  }

  /** Opens the task-detail drawer for a card tap using the same path as a grid row click.
   *  The setTimeout avoids a mobile click-retarget race where the same tap can
   *  hit the drawer close button immediately after open. */
  onCardTap(task: ITaskResponse, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    this.isTaskDetailLoadedSubject$.next(false);
    this.selectedRowData.length = 0;
    this.selectedRowData.push(task);
    this.selectedSectionIndex = 0;

    setTimeout(() => {
      this.openDrawer({ data: task });
    }, 0);
  }

  /** Returns a CSS modifier class for a task status badge on the card. */
  getCardStatusClass(status: string): string {
    if (!status) return '';
    switch (status.toLowerCase()) {
      case 'open':               return 'card-status--open';
      case 'closed':
      case 'completed':          return 'card-status--closed';
      case 'rejected':           return 'card-status--rejected';
      case 'pending':
      case 'pending client':
      case 'client hold':        return 'card-status--pending';
      case 'cancelled':          return 'card-status--cancelled';
      case 'not applicable':     return 'card-status--na';
      default:                   return '';
    }
  }

  /** Returns a CSS class for an overdue / due-today due-date label on the card. */
  getCardDueDateClass(task: ITaskResponse): string {
    if (!task.dueDate) return '';
    const due = new Date(task.dueDate);
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const closedStatuses = ['closed','completed','cancelled','rejected','not applicable'];
    if (closedStatuses.includes((task.status || '').toLowerCase())) return '';
    if (due < today) return 'card-due--overdue';
    if (due.toDateString() === today.toDateString()) return 'card-due--today';
    return '';
  }

  dataSource: CustomStore;
  // Set just before a SignalR-triggered refresh so LoadTaskData() can skip showing isLoading for it.
  private isSilentGridRefresh = false;
  rowData: ITaskResponse[] = [];
  userData: any;
  deals: any[] = [];
  priority: any[] = [];
  isLoaded: boolean = false;
  selectedTask: any;
  taskColumnData: IGridColumn[] = [];
  subTaskColumnData: IGridColumn[];
  onEditorPreparing: Function = () => null;
  refreshMode: string = 'full';
  contextMenuItems: Record<any, unknown>[];
  today: Date = new Date();
  taskNavigationFilterParameters: any; //ITasksNavigation;
  isLoading: boolean = false;
  addNewText: string;
  storageKey: string;
  myTasksSelected: boolean;
  myTeamsTaskFilter: FilterDescriptor = [];
  mySubtasksFilter: FilterDescriptor = [];
  taskFilters: Map<string, FilterDescriptor> = new Map<
    string,
    FilterDescriptor
  >();
  taskOrFilters: Map<string, FilterDescriptor> = new Map<
    string,
    FilterDescriptor
  >();
  taskStatuses: any;
  selectedDateRange: any;
  selectedRowKeys: any[] = [];
  selectedRowData: any[] = [];
  // Tracks which nested per-parent subtask grid (if any) the current selection came from,
  // so clearSelectedRows() can deselect the right widget instance.
  private activeDetailGridInstance: any = null;
  templateName: string;
  notificationsVisible: boolean = false;
  datagridButtons: IButtonConfig[];

  messages: Message[] = [];
  assignedUserPopupVisible: boolean = false;
  rowSelectionChanged: boolean = false;
  teamUsers: any[];
  isEditable: boolean = false;
  isEditableSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isEditable$ = this.isEditableSubject$.asObservable();
  isCompleteable: boolean = false;
  isCompleteableSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isCompleteable$ = this.isCompleteableSubject$.asObservable();
  isTaskDetailLoaded: boolean = false;
  isTaskDetailLoadedSubject$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  isTaskDetailLoaded$ = this.isTaskDetailLoadedSubject$.asObservable();
  selectedTaskSubject$: BehaviorSubject<ITaskResponse> = new BehaviorSubject(
    null
  );
  selectedTask$ = this.selectedTaskSubject$.asObservable();
  filteredByDashboardTaskIds: boolean = false;
  resetFilters: boolean = false;
  filteredExternallyMessage: string = 'Filtered by dashboard selection';
  showSearchPanel: boolean = true;
  sharepointRootUrl: string;
  rejectTasksPopupVisible: boolean = false;
  holdTaskPopupVisible: boolean = false;
  showCommentsVisible: boolean = false;
  rollbackTasks: ITaskResponse[] = [];
  holdTask: ITaskResponse | null = null;
  flattenedList: boolean = false;
  showCompleted: boolean = false;
  showCompletedSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showCompleted$ = this.showCompletedSubject$.asObservable();
  showRejected: boolean = false;
  showRejectedSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showRejected$ = this.showRejectedSubject$.asObservable();
  isEditTask: boolean = false;

  // Track if "Subtasks with Attachments" scope filter is selected
  isSubtasksWithAttachmentsSelected: boolean = false;

  // Flag to trigger auto-expand of parent rows after Subtasks with Attachments data loads
  private needsAutoExpand: boolean = false;
  private isApplyingGridContentReady: boolean = false;

  // Flag set when navigating to a parent via "Go To Parent" context menu action.
  // Overrides the My Subtasks scope hiding of the chat/documents buttons column.
  private isNavigatedToParent: boolean = false;

  // Store the current scope name to send with all requests
  private currentScopeName: string = 'My Subtasks';
  private facilityDisplayCache = new Map<string, Promise<string | undefined>>();

  // Predicate to highlight subtasks assigned to the current user
  subtaskHighlightPredicate = (rowData: any): boolean =>
    rowData?.assignedUserId === localStorage.getItem('loggedInUserId');

  // Predicate to highlight urgent voucher parent tasks in pink
  urgentVoucherRowHighlightPredicate = (rowData: any): boolean =>
     rowData?.taskId?.startsWith('VOU-') && rowData?.isUrgent === true;

  // Statuses that exclude a subtask from bulk-action selection; isClosedStatus is an additional backstop.
  private readonly bulkActionBlockedStatuses = new Set(['Closed', 'Rejected', 'Not Applicable', 'Cancelled']);

  isTaskRowSelectable = (rowData: any): boolean =>
    !rowData?.isClosedStatus && !this.bulkActionBlockedStatuses.has(rowData?.status);

  isUrgentDueDateRow = (rowData: any): boolean =>
    this.isUrgentPrimaryServicingPaymentInstruction(rowData);

  // Store hold status names for checking
  private holdStatusNames: string[] = [];

  // Flag to ensure task data is loaded only once on first hold status population
  private isTaskDataLoaded: boolean = false;

  // Define fields that are derived from taskData JSON
  private taskDataDerivedFieldMap: Record<string, string> = {
    amount: 'amount',
    voucherAmount: 'voucherAmount',
    borrowerName: 'borrowers',
    category: 'category',
    frequency: 'frequency',
    currency: 'currency',
    customerName: 'customerName',
    accountNumber: 'accountNumber',
    dealName: 'dealName',
    debitBank: 'debitBank',
    paymentMethod: 'paymentMethod',
    voucherDueDate: 'voucherDueDate',
    isUrgent: 'isUrgent',
    treasuryProvideFedRefNumbers: 'treasuryProvideFedRefNumbers',
    feesPaidToMS: 'feesPaidToMS',
    billableToClient: 'billableToClient',
  };

  private readonly booleanTaskDataDerivedFields = new Set<string>([
    'isUrgent',
    'treasuryProvideFedRefNumbers',
    'feesPaidToMS',
    'billableToClient',
  ]);

  // Declared once here to avoid re-allocating on every enrichRowData() call
  private readonly taskDataFieldMappings: { [key: string]: string[] } = {
    borrowerName: ['borrowers', 'borrowerName'],
    category: ['category'],
    frequency: ['frequency'],
    currency: ['currency', 'currencyCode', 'ccy'],
    customerName: ['customerName', 'client', 'borrower', 'clientName'],
    accountNumber: ['accountNumber', 'account', 'accountNo', 'acctNum'],
    dealName: ['dealName'],
    debitBank: ['debitBank'],
    paymentMethod: ['paymentMethod'],
    voucherDueDate: ['voucherDueDate', 'dueDate'],
    isUrgent: ['isUrgent'],
    treasuryProvideFedRefNumbers: ['treasuryProvideFedRefNumbers'],
    feesPaidToMS: ['feesPaidToMS'],
    billableToClient: ['billableToClient'],
    voucherAmount: ['voucherAmount'],
    fedReferenceNumbers: ['fedReferenceNumbers'],
  };

  // Configuration for editable fields (matches task-detail component)
  editableFields: object[] = [
    {
      prefix: "SUS",
      fields: [
        { name: "amount", format: "currency" }
      ]
    }
  ];

  readonly dateRangeKey: string = 'dateRangeKey';
  readonly myTasksKey: string = 'myTasks';
  readonly selectedViewKey: string = 'tasksSelectedView';
  readonly viewOptions: string[] = ['Default', 'Voucher', 'F&C'];
  selectedView: string = 'Default';

  get gridStorageKey(): string {
    return this.selectedView === 'Voucher' ? 'Tasks_Grid_Voucher' : 'Tasks_Grid';
  }

  // drawer settings
  openedStateMode: DxDrawerTypes.OpenedStateMode = 'overlap';
  selectedPosition: DxDrawerTypes.PanelLocation = 'right';
  selectedRevealMode: DxDrawerTypes.RevealMode = 'slide';
  isDrawerOpen!: boolean;

  /** Responsive drawer panel size so mobile/tablet never overshoots off-screen. */
  get drawerMaxSize(): number {
    if (typeof window === 'undefined') return 1200;
    const horizontalPadding = window.innerWidth < 768 ? 8 : 32;
    const availableWidth = window.innerWidth - horizontalPadding;
    return Math.max(280, Math.min(1200, availableWidth));
  }

  //grid settings
  displayMode: DxoPagerComponent['displayMode'] = 'full';
  allowedPageSizes: DxoPagerComponent['allowedPageSizes'] = 'auto';
  showPageSizeSelector = true;
  showInfo = true;
  showNavButtons = true;

  taskTemplates: any[];

  gridFilterOptions: DatePanelItems[] = datePanelItems;

  // context menu keys
  assign: string = 'assign';
  complete: string = 'Complete';
  notApplicable: string = 'Not Applicable';
  redo: string = 'Redo';
  assignToUser: string = 'assignToUser';
  hold: string = 'hold';
  cancel: string = 'cancel';
  goToParent: string = 'goToParent';
  goToBatch: string = 'goToBatch';
  editTask: string = 'editTask';

  //popup
  addNewTaskVisible: boolean = false;
  addNewTemplateType: string;
  taskMetadata: any;

  userPreferenceActions: Array<{ id: number; icon: string; class: string }> = [
    { id: 1, icon: 'save', class: 'dx-button' },
    { id: 2, icon: 'clear', class: 'dx-button' },
  ];
  dropDownOptions = {
    height: 100,
    width: 80,
  };

  addNewDropDownOptions = {
    height: 150,
    width: 250,
  };

  filterDropDownOptions = {
    height: 150,
    width: 200,
  };
  newTaskPopupHeight: any;
  newTaskPopupWidth: any;
  radioGroupValue: any = { Due: null, Scope: null };
  selectedSectionIndex: number = 0;

  onAddNewTask(e: any) {
    this.addNewTaskVisible = false;
    this.dataGridTasks.getDataSource()?.reload();
  }

  onTaskCommentPosted(taskId: string): void {
    if (!taskId || !this.dataGridTasks) {
      return;
    }

    // Refresh to ensure comment badges and counts stay in sync after chat posts.
    this.dataGridTasks.getDataSource().reload();
  }

  onNewTaskPopupHiding(e: any) {
    this.addNewTaskVisible = false;
    this.selectedTaskSubject$.next(null);
  }

  onAddNew(e: any) {
    this.taskMetadata = null;
    this.createOrEditTask(e.itemData.templateType);
  }

  createOrEditTask(templateType: string, isEdit: boolean = false) {
    this.isEditTask = isEdit;
    this.addNewTemplateType = templateType;
    this.templateName = templateType;
    this.ref.detectChanges();

    const { width, height } = this.getResponsivePopupSize(this.addNewTemplateType);
    this.newTaskPopupWidth = width;
    this.newTaskPopupHeight = height;

    this.addNewTaskVisible = !this.addNewTaskVisible;
  }

  private getResponsivePopupSize(templateType: string): { width: number | string; height: number | string } {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const rw = (maxPx: number) => Math.min(maxPx, Math.round(vw * 0.9));
    const rh = (maxPx: number) => Math.min(maxPx, Math.round(vh * 0.9));
    switch (templateType) {
      case 'F&C':
      case 'Financial and Compliance':
      case 'FandC':
        return { width: '82%', height: rh(900) };
      case 'LS&B':
        return { width: '60%', height: rh(750) };
      case 'Surveillance':
        return { width: rw(1050), height: rh(900) };
      case 'Loan Management':
        return { width: rw(1050), height: rh(900) };
      case 'Pipeline':
      case 'Modification':
        return { width: rw(550), height: rh(900) };
      case 'Suspense Request':
        return { width: rw(650), height: rh(750) };
      default:
        return { width: rw(650), height: rh(900) };
    }
  }

  onDateFilter(e: DxRadioGroupTypes.OptionChangedEvent) {
    switch (e.value.type) {
      case 'Due':
        this.selectedDateRange = e.value;
        localStorage.setItem(this.dateRangeKey, e.value.key);
        this.buildDateFilter(e.value);
        // Update the FilterStateService with the new Due filter selection
        this.updateFilterStateForDue(e.value);
        break;
      case 'Scope':
        localStorage.setItem(this.myTasksKey, e.value.key);
        this.onMyTasksChanged(e.value.key, false);
        // Update the FilterStateService with the new Scope filter selection
        this.updateFilterStateForScope(e.value);
        break;

      default:
        break;
    }
    // console.log(this.taskFilters);
    this.reloadGridPreservingState();
  }

  onSelectedViewChanged(e: any): void {
    const nextView = this.normalizeSelectedView(e?.value);

    if (this.selectedView === nextView) {
      return;
    }

    this.selectedView = nextView;
    localStorage.setItem(this.selectedViewKey, this.selectedView);
    this.applySelectedView(true);
  }

  private applySelectedView(reloadGrid: boolean = false): void {
    this.setTaskGridColumnData();
    this.getDataGridButtons();

    if (reloadGrid && this.dataGridTasks?.dataGrid?.instance) {
      // detectChanges propagates the new gridStorageKey binding to the child component
      // so that subsequent save/load operations use the correct per-view key.
      this.ref.detectChanges();

      // Now reload the saved state for the new key before refreshing data.
      this.dataGridTasks.reloadGridState();
      this.dataGridTasks.getDataSource()?.reload();
    }
  }

  private normalizeSelectedView(view: string | null | undefined): string {
    return this.viewOptions.includes(view || '') ? view : 'Default';
  }

  buildDateFilter(datePanelItem: DatePanelItem) {
    let startDateKey = 'startDate';
    let endDateKey = 'endDateDate';
    let operatorKey = 'dateOperatorKey';
    let joinDateOperatorKey = 'joinDateOperatorKey';

    this.taskFilters.delete(joinDateOperatorKey);
    this.taskFilters.delete(startDateKey);
    this.taskFilters.delete(operatorKey);
    this.taskFilters.delete(endDateKey);

    if (datePanelItem.text != 'All') {
      if (this.taskFilters.size > 0) {
        this.taskFilters.set(joinDateOperatorKey, 'and');
      }

      this.taskFilters.set(endDateKey, [
        'dueDate',
        '<=',
        datePanelItem.endDate,
      ]);
    }
  }

  buildTaskFilter(taskFilterItem: any) {
    // console.log(taskFilterItem);
    let filterKey = 'filterKey';
    let operatorKey = 'filterOperatorKey';

    this.taskFilters.delete(filterKey);

    this.taskFilters.set(filterKey, ['taskField', '=', taskFilterItem.key]);
    this.taskFilters.set(operatorKey, 'and');
  }

  private getSelectedViewFilter(): FilterDescriptor {
    if (this.selectedView === 'Voucher') {
      return ['taskId', 'startswith', 'VOU'];
    }

    if (this.selectedView === 'F&C') {
      return [
        ['taskId', 'startswith', 'SCH'],
        'or',
        ['taskId', 'startswith', 'FAC'],
      ];
    }

    return [];
  }

  showRejectedChanged(e: any, reload = true) {
    this.showRejected = Boolean(e.value);
    this.showRejectedSubject$.next(this.showRejected);

    let rejectedKey = 'showRejected';
    let pendingKey = 'showPending';
    let blockedKey = 'showBlocked';
    let joinKey = 'joinOrKey';
    let joinOrPendingKey = 'joinPendingKey';
    let joinOrBlockedKey = 'joinBlockedKey';
    let joinShowKey = 'joinShowKey';

    this.taskOrFilters.delete(rejectedKey);
    this.taskOrFilters.delete(joinKey);
    this.taskOrFilters.delete(pendingKey);
    this.taskOrFilters.delete(blockedKey);
    this.taskOrFilters.delete(joinOrPendingKey);
    this.taskOrFilters.delete(joinOrBlockedKey);
    this.taskOrFilters.delete(joinShowKey);

    // Clear any existing blocked status filters
    const keysToDelete = Array.from(this.taskOrFilters.keys()).filter(key =>
      key.startsWith(blockedKey) || key.startsWith(joinOrBlockedKey)
    );
    keysToDelete.forEach(key => this.taskOrFilters.delete(key));

    // Only add initial joinKey if there are already other filters
    const hasOtherFilters = this.taskOrFilters.size > 0;
    if (hasOtherFilters) {
      this.taskOrFilters.set(joinKey, 'or');
    }

    if (e.value) {
      // Add rejected status (first item in this group, no join operator needed)
      this.taskOrFilters.set(rejectedKey, ['status', '=', 'rejected']);

      // Add pending status (needs join operator since rejected is already added)
      this.taskOrFilters.set(joinOrPendingKey, 'or');
      this.taskOrFilters.set(pendingKey, ['status', '=', 'pending']);

      // Add hold statuses using cached holdStatusNames
      if (this.holdStatusNames && this.holdStatusNames.length > 0) {
        this.holdStatusNames.forEach((statusName, index) => {
          const blockedStatusKey = `${blockedKey}_${index}`;
          const joinBlockedStatusKey = `${joinOrBlockedKey}_${index}`;

          // Add join operator before each blocked status
          this.taskOrFilters.set(joinBlockedStatusKey, 'or');
          this.taskOrFilters.set(blockedStatusKey, ['status', '=', statusName]);
        });
      }

      if (reload) {
        this.flattenedList = true;
        this.dataGridTasks.getDataSource()?.reload();
      }
    } else {
      // When Show Rejected is deselected, still include pending and blocked statuses
      this.taskOrFilters.set(pendingKey, ['status', '=', 'pending']);

      // Add hold statuses even when rejected is not shown, using cached holdStatusNames
      if (this.holdStatusNames && this.holdStatusNames.length > 0) {
        this.holdStatusNames.forEach((statusName, index) => {
          const holdStatusKey = `${blockedKey}_${index}`;
          const joinHoldStatusKey = `${joinOrBlockedKey}_${index}`;

          // Add join operator before each blocked status
          this.taskOrFilters.set(joinHoldStatusKey, 'or');
          this.taskOrFilters.set(holdStatusKey, ['status', '=', statusName]);
        });
      }

      if (reload) {
        this.flattenedList = true;
        this.reloadGridPreservingState();
      }
    }
    localStorage.setItem('showRejected', e.value);

    // Update the FilterStateService with the new value
    this.filterStateService.updateShowRejected(e.value);
  }

  showCompletedChanged(e: any, reload = true) {
    this.showCompleted = Boolean(e.value);
    this.showCompletedSubject$.next(this.showCompleted);

    let key = 'showCompleted';
    let joinKey = 'joinShowKey';
    let completedStatusKey = 'completedStatus';
    let closedStatusKey = 'closedStatus';
    let cancelledStatusKey = 'cancelledStatus';
    let completedOrKey = 'completedOrKey';
    let openOrKey = 'openOrKey';
    let cancelledOrKey = 'cancelledOrKey';
    let notApplicableOrKey = 'notApplicableOrKey';
    let notApplicableStatusKey = 'notApplicableStatus';

    this.taskOrFilters.delete(key);
    this.taskOrFilters.delete(joinKey);
    this.taskOrFilters.delete(completedStatusKey);
    this.taskOrFilters.delete(closedStatusKey);
    this.taskOrFilters.delete(cancelledStatusKey);
    this.taskOrFilters.delete(completedOrKey);
    this.taskOrFilters.delete(openOrKey);
    this.taskOrFilters.delete(cancelledOrKey);
    this.taskOrFilters.delete(notApplicableOrKey);
    this.taskOrFilters.delete(notApplicableStatusKey);

    if (this.taskOrFilters.size > 0) {
      this.taskOrFilters.set(joinKey, 'or');
    }
    this.taskOrFilters.set(key, ['status', '=', 'open']);

    if (e.value) {
      if (this.taskOrFilters.size > 0) {
        this.taskOrFilters.set(joinKey, 'or');
      }
      this.taskOrFilters.set(key, ['status', '=', 'open']);
      this.taskOrFilters.set(openOrKey, 'or');
      this.taskOrFilters.set(completedStatusKey, ['status', '=', 'completed']);
      this.taskOrFilters.set(completedOrKey, 'or');
      this.taskOrFilters.set(closedStatusKey, ['status', '=', 'closed']);
      this.taskOrFilters.set(cancelledOrKey, 'or');
      this.taskOrFilters.set(cancelledStatusKey, ['status', '=', 'cancelled']);
      this.taskOrFilters.set(notApplicableOrKey, 'or');
      this.taskOrFilters.set(notApplicableStatusKey, ['status', '=', 'not applicable']);
    }

    localStorage.setItem('showCompleted', e.value);

    // Update the FilterStateService with the new value
    this.filterStateService.updateShowCompleted(e.value);

    if (reload) {
      this.reloadGridPreservingState();
    }
  }

  onMyTasksChanged(task: any, reload = true) {
    let joinTasksKey = 'joinTasksKey';

    this.taskFilters.delete(this.myTasksKey);

    this.myTeamsTaskFilter.length = 0;
    this.mySubtasksFilter.length = 0;
    this.taskFilters.delete(joinTasksKey);

    // Track if "Subtasks with Attachments" is selected (task == 3)
    // Use == to allow for type coercion (handles both 3 and "3")
    this.isSubtasksWithAttachmentsSelected = (task == 3);

    if (task == 0) {
      // "My Subtasks": filter by tasks assigned to the current user
      // Using a separate filter (like myTeamsTaskFilter) ensures assignedUserId
      // is included in every request regardless of other grid filters
      this.mySubtasksFilter = ['assignedUserId', '=', localStorage.getItem('loggedInUserId')];
      this.currentScopeName = 'My Subtasks';
    } else if (task == 1) {
      // My Team Tasks: server-side filter for tasks in my teams
      this.myTeamsTaskFilter = ['myTeams', '=', true];
      this.currentScopeName = 'My Team Tasks';
    } else if (task == 2) {
      // All: no scope filter applied
      this.currentScopeName = 'All';
    } else if (task == 3) {
      // Subtasks with Attachments: team filter + client-side subtask post-filter + auto-expand.
      // The open/pending status restriction is already present in taskOrFilters by default
      // via showCompletedChanged ('showCompleted' key) and showRejectedChanged ('showPending' key).
      this.myTeamsTaskFilter = ['myTeams', '=', true];
      this.needsAutoExpand = true;
      this.currentScopeName = 'Subtasks with Attachments';
    }

    console.log('onMyTasksChanged - task:', task, 'isSubtasksWithAttachmentsSelected:', this.isSubtasksWithAttachmentsSelected);

    // Changing scope resets the "Go To Parent" navigation state
    this.isNavigatedToParent = false;

    // Refresh buttons (always shown regardless of scope filter)
    this.getDataGridButtons();

    if (reload) {
      // Refresh the data grid to apply column visibility changes
      this.reloadGridPreservingState();
      // Force change detection to update the grid UI
      this.ref.detectChanges();
    }
  }

  /**
   * Reloads the data grid while preserving user-applied filters and sorting.
   * This ensures that when quick filters change, the user's manual grid filters
   * are maintained instead of being lost.
   */
  private reloadGridPreservingState(): void {
    if (!this.dataGridTasks?.dataGrid?.instance) {
      return;
    }

    // DevExtreme preserves user-applied filters, sorting, and search state across reload()
    // calls automatically. No manual state save/restore is needed, and doing so causes
    // a second server request because setting grid state triggers another load.
    this.dataGridTasks.getDataSource()?.reload();

    // Reload the card list (< 1024px) with the same filter state so both views stay in sync.
    this.cardListEl?.instance?.reload();
  }

  buildOrTasksFilterArray(
    hasloadOptionsFilterData: boolean
  ): Array<FilterDescriptor> {
    let joinKey = 'joinOrKey';

    let filterArray: Array<FilterDescriptor> = new Array<FilterDescriptor>();
    let firstKey = this.taskOrFilters.keys().next();

    if (this.taskOrFilters.size > 0 && firstKey.value == joinKey)
      this.taskOrFilters.delete(joinKey);

    this.taskOrFilters.forEach((filter) => {
      filterArray.push(filter);
    });

    return filterArray;
  }

  buildTaskFilterArray(
    hasloadOptionsFilterData: boolean
  ): Array<FilterDescriptor> {
    let key = 'andKey';
    let joinDateOperatorKey = 'joinDateOperatorKey';
    let joinTasksKey = 'joinTasksKey';
    let joinShowKey = 'joinShowKey';

    let filterArray: Array<FilterDescriptor> = new Array<FilterDescriptor>();

    this.taskFilters.delete(key);

    let firstKey = this.taskFilters.keys().next();

    if (this.taskFilters.size > 0 && firstKey.value == joinDateOperatorKey)
      this.taskFilters.delete(joinDateOperatorKey);

    if (this.taskFilters.size > 0 && firstKey.value == joinTasksKey)
      this.taskFilters.delete(joinTasksKey);

    if (this.taskFilters.size > 0 && firstKey.value == joinShowKey)
      this.taskFilters.delete(joinShowKey);

    if (hasloadOptionsFilterData && this.taskFilters.size > 0) {
      this.taskFilters.set(key, 'and');
    }

    this.taskFilters.forEach((filter) => {
      filterArray.push(filter);
    });

    return filterArray;
  }

  onRowSelectionChanged(e: DxDataGridTypes.SelectionChangedEvent) {
    this.selectedRowKeys = e.selectedRowKeys;
    this.selectedRowData = e.selectedRowsData;
    this.activeDetailGridInstance = null;

    if (this.selectedRowKeys.length > 0) {
      this.rowSelectionChanged = true;
    } else {
      this.rowSelectionChanged = false;
    }
  }

  // Subtask checkbox selection within one expanded parent's nested grid; replaces the current
  // selection rather than merging, since bulk actions apply to one expanded parent at a time.
  onDetailRowSelectionChanged(e: { masterTaskData: any; component: any; selectedRowKeys: any[]; selectedRowsData: any[] }) {
    this.selectedRowKeys = e.selectedRowKeys;
    this.selectedRowData = e.selectedRowsData;
    this.rowSelectionChanged = this.selectedRowKeys.length > 0;
    this.activeDetailGridInstance = this.rowSelectionChanged ? e.component : null;
  }

  onContextMenuPreparing(e: any) {
    if (e.row.rowType == 'data') {
      this.getContextMenuItems(e);
    }
  }

  onExportToExcel(e: any) {
    const workbook = new Workbook();
    const dataGrid = e.component;

    const visibleRows =
      dataGrid.getSelectedRowsData().length > 0
        ? dataGrid.getSelectedRowsData()
        : dataGrid
            .getVisibleRows()
            .filter((data) => data.rowType == 'data')
            .map((row) => row.data);

    if (visibleRows.length === 0) return;

    const worksheet = workbook.addWorksheet('Tasks');

    // Get master columns (exclude buttons column, non-visible columns, and taskData which gets exploded)
    const masterColumns = this.taskColumnData.filter(
      (col) => col.field && col.field !== '' && col.visible !== false && col.field !== 'taskData'
    );

    // Get detail columns (exclude non-visible columns and taskData which gets exploded)
    const detailColumns = this.subTaskColumnData.filter(
      (col) => col.visible !== false && col.field !== 'taskData'
    );

    // Compute detailOnlyColumns early so it can be used for deduplication below
    const detailOnlyColumns = detailColumns.filter(
      (detailCol) => !masterColumns.some((masterCol) => masterCol.field === detailCol.field)
    );

    // Build the set of taskData keys that are already represented by a visible grid column,
    // so they are not repeated in the exploded columns section.
    // 1. Direct matches: taskData key equals a column field name.
    const allColumnFields = new Set<string>(
      [...masterColumns, ...detailOnlyColumns].map(col => col.field).filter(Boolean)
    );
    // 2. Indirect matches: a column is derived from a differently-named taskData key.
    const coveredTaskDataKeys = new Set<string>(allColumnFields);
    Object.entries(this.taskDataDerivedFieldMap).forEach(([colField, taskDataKey]) => {
      if (allColumnFields.has(colField)) {
        coveredTaskDataKeys.add(taskDataKey);
      }
    });
    if (allColumnFields.has('voucherDueDate')) {
      coveredTaskDataKeys.add('dueDate');
    }

    // First pass: collect all unique taskData keys not already covered by a grid column
    const taskDataKeysOrdered: string[] = [];
    const taskDataKeySet = new Set<string>();
    const collectTaskDataKeys = (taskData: string | undefined) => {
      if (!taskData) return;
      try {
        const parsed = JSON.parse(taskData);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          Object.keys(parsed).forEach((key) => {
            if (!taskDataKeySet.has(key) && !coveredTaskDataKeys.has(key)) {
              taskDataKeySet.add(key);
              taskDataKeysOrdered.push(key);
            }
          });
        }
      } catch {}
    };
    visibleRows.forEach((row) => {
      collectTaskDataKeys(row.taskData);
      (row.subTasks || []).forEach((sub: any) => collectTaskDataKeys(sub.taskData));
    });

    // Helper to convert camelCase / PascalCase keys to Title Case for headers
    const toTitleCase = (key: string): string =>
      key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (ch) => ch.toUpperCase())
        .trim();

    // Create header row: Record Type | master cols | subtask-only cols | exploded taskData keys

    const allHeaders = [
      'Record Type',
      ...masterColumns.map((col) => col.title),
      ...detailOnlyColumns.map((col) => col.title),
      ...taskDataKeysOrdered.map(toTitleCase)
    ];

    const headerRow = worksheet.addRow(allHeaders);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD3D3D3' }
    };

    // Enable auto-filter
    worksheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: allHeaders.length },
    };

    // Configure column formatting (taskData exploded columns are string/auto)
    const allColumnConfigs: any[] = [
      { dataType: 'string' }, // Record Type column
      ...masterColumns,
      ...detailOnlyColumns,
      ...taskDataKeysOrdered.map(() => ({ dataType: 'string' }))
    ];

    for (let i = 0; i < allColumnConfigs.length; i++) {
      const colConfig = allColumnConfigs[i];
      if (colConfig.dataType === 'date') {
        worksheet.getColumn(i + 1).numFmt =
          locale() === 'en-US' ? 'mm/dd/yyyy' : 'dd/mm/yyyy';
      } else if (colConfig.dataType === 'datetime') {
        worksheet.getColumn(i + 1).numFmt =
          locale() === 'en-US'
            ? 'mm/dd/yyyy hh:mm AM/PM'
            : 'dd/mm/yyyy hh:mm:ss';
      }
    }

    // Helper: extract ordered taskData values for a row (empty string when key absent)
    const extractTaskDataValues = (taskData: string | undefined): any[] => {
      if (!taskData) return new Array(taskDataKeysOrdered.length).fill('');
      try {
        const parsed = JSON.parse(taskData);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          return taskDataKeysOrdered.map((key) => {
            const val = parsed[key];
            return val !== undefined && val !== null ? val : '';
          });
        }
      } catch {}
      return new Array(taskDataKeysOrdered.length).fill('');
    };

    // Get all field names in order (without taskData)
    const masterFields = masterColumns.map((col) => col.field);
    const detailOnlyFields = detailOnlyColumns.map((col) => col.field);

    // Process each visible row
    visibleRows.forEach((row) => {
      // Add master row
      const masterRowData = [
        'Task',
        ...this.mapExcelFields(masterFields, row),
        ...new Array(detailOnlyFields.length).fill(''),
        ...extractTaskDataValues(row.taskData)
      ];
      const masterExcelRow = worksheet.addRow(masterRowData);
      masterExcelRow.font = { bold: true };
      masterExcelRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF0F0F0' }
      };

      // Add detail rows (subtasks)
      const detailData = row.subTasks || [];
      if (detailData.length > 0) {
        detailData.forEach((detailRow) => {
          // Get master values for comparison
          const masterValues = this.mapExcelFields(masterFields, row);
          const detailValues = this.mapExcelFields(masterFields, detailRow);

          // Define columns where matching values should be excluded
          const excludeIfMatchingColumns = ['referenceName', 'amount', 'workflow'];

          // Only hide detail values for specific columns if they match master
          const detailRowDataWithDiffs = detailValues.map((detailValue, index) => {
            const fieldName = masterFields[index];
            const masterValue = masterValues[index];

            // Only apply the blank-if-equal logic to specific columns
            if (excludeIfMatchingColumns.includes(fieldName) &&
                this.areValuesEqual(masterValue, detailValue)) {
              return ''; // Blank if same as master for these specific columns
            }
            return detailValue; // Always show for other columns
          });

          const detailRowData = [
            'Subtask',
            ...detailRowDataWithDiffs,
            ...this.mapExcelFields(detailOnlyFields, detailRow),
            ...extractTaskDataValues(detailRow.taskData)
          ];
          const detailExcelRow = worksheet.addRow(detailRowData);
          // Indent detail rows slightly for visual hierarchy
          detailExcelRow.outlineLevel = 1;
        });
      }
    });

    // Auto-size columns
    worksheet.columns.forEach((column, index) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellLength = cell.value ? cell.value.toString().length : 0;
        if (cellLength > maxLength) maxLength = cellLength;
      });

      const colConfig = allColumnConfigs[index];
      if (colConfig?.dataType === 'date') {
        column.width = 12;
      } else if (colConfig?.dataType === 'datetime') {
        column.width = 20;
      } else {
        column.width = Math.min(Math.max(maxLength + 2, 10), 50);
      }
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      FileSaver.saveAs(
        new Blob([buffer], { type: 'application/octet-stream' }),
        `${this.storageKey}.xlsx`
      );
    });
  }

  mapExcelFields(dataFields: any[], row: any): any[] {
    return dataFields.map((col) => {
      let value = row[col];

      // Convert string to Date only if it's a valid ISO format and convert UTC to local time
      if (
        typeof value === 'string' &&
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(
          value
        )
      ) {
        const utcDate = new Date(value);
        // Convert UTC to local time by adjusting for timezone offset
        value = new Date(
          utcDate.getTime() - utcDate.getTimezoneOffset() * 60000
        );
      }

      return value;
    });
  }

  areValuesEqual(value1: any, value2: any): boolean {
    // Handle null and undefined
    if (value1 === value2) return true;
    if (value1 == null && value2 == null) return true;
    if (value1 == null || value2 == null) return false;

    // Handle Date objects
    if (value1 instanceof Date && value2 instanceof Date) {
      return value1.getTime() === value2.getTime();
    }

    // Handle arrays (for complex objects)
    if (Array.isArray(value1) && Array.isArray(value2)) {
      return JSON.stringify(value1) === JSON.stringify(value2);
    }

    // Handle objects
    if (typeof value1 === 'object' && typeof value2 === 'object') {
      return JSON.stringify(value1) === JSON.stringify(value2);
    }

    // Handle primitive values with string conversion (for numbers vs strings comparison)
    return String(value1) === String(value2);
  }

  isCreator(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some(
        (item) => item.createdBy == localStorage.getItem('loggedInUser')
      );
    }

    return false;
  }

  hasSubTasks(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some(
        (item) => Array.isArray(item.subTasks) && item.subTasks.length > 0
      );
    }
    return false;
  }

  isSubTask(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some((item) => item.parentId != null);
    }

    return false;
  }

  isParentTask(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some((item) => item.parentId == null);
    }

    return false;
  }

  isStandaloneTask(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some(
        (item) => item.parentId == null && item.subTasks.length == 0
      );
    }
    return false;
  }

  isFirstTask(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some((item) => item.sequenceNumber == 1);
    }
    return false;
  }

  isBulkSelection(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.length > 1 ? true : false;
    }
    return false;
  }

  isBatchTask(): boolean {
    if (!this.selectedRowData || this.selectedRowData.length === 0) {
      return false;
    }

    // Check if first item has a metadata ID
    const firstMetadataId = this.selectedRowData[0]?.taskGenerationMetadataId;
    if (!firstMetadataId) {
      return false;
    }

    // Check if all items have the same non-null metadata ID
    return this.selectedRowData.every(
      (item) =>
        item.taskGenerationMetadataId &&
        item.taskGenerationMetadataId === firstMetadataId
    ) && this.selectedRowData[0].name.toUpperCase() !== 'REVIEW';
  }

  canGoToBatch(): boolean {
    if (!this.selectedRowData || this.selectedRowData.length === 0) {
      return false;
    }

    const taskId = this.selectedRowData[0]?.taskId;
    const hasFacPrefix = typeof taskId === 'string' && taskId.toUpperCase().startsWith('FAC');

    return this.isBatchTask() || hasFacPrefix;
  }

  private getUserTeams(): string[] {
    try {
      const raw = localStorage.getItem('userTeams');
      if (raw == null) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  isUserInTaskTeam(): boolean {
    if (this.selectedRowData != null) {
      const teams = this.getUserTeams();
      return this.selectedRowData.every((item) => teams.includes(item.team));
    }
    return false;
  }

  isUserInInitiationTaskEditTeam(): boolean {
    if (this.selectedRowData != null) {
      const teams = this.getUserTeams();
      return teams.includes('Initiation Task Editing');
    }
    return false;
  }

  isUserInTeam(teamName: string): boolean {
    if (this.selectedRowData != null) {
      const teams = this.getUserTeams();
      return teams.some((item: string) => item === teamName);
    }
    return false;
  }

  // EU-only: anyone can assign a subtask outside their own team; assignee is still team-scoped by showUserLookUp
  isEuSubtaskAssignmentBypass(): boolean {
    return this.featureFlagsService.isEu() && !this.isParentTask();
  }

  isOpen(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some((item) => item.status == 'Open');
    }
    return false;
  }

  isCompleted(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some(
        (item) => item.status == 'Closed' || item.status == 'Completed'
      );
    }
    return false;
  }

  isPending(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some((item) => item.status == 'Pending');
    }
    return false;
  }
  isOnHold(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some((item) => item.status == 'Pending Client' || item.status == 'Client Hold');
    }
    return false;
  }

  isRejected(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some((item) => item.status == 'Rejected');
    }
    return false;
  }

  isAssignedToCurrentUser(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some(
        (item) => item.assignedUserName == localStorage.getItem('loggedInUser')
      );
    }
    return false;
  }

  userIsCreator(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some(
        (item) => item.createdBy == localStorage.getItem('loggedInUser')
      );
    }
    return false;
  }

  isInitiationTask(): boolean {
    if (this.selectedRowData != null) {
      return this.selectedRowData.some(
        (item) => item.name.toUpperCase() == 'INITIATION'
      );
    }
    return false;
  }

  isHeld(): boolean {
    if (this.selectedRowData != null && this.selectedRowData.length > 0) {
      // Check if any selected task has a status that matches the hold statuses from the service
      return this.selectedRowData.some((item) => {
        return this.holdStatusNames.includes(item.status);
      });
    }
    return false;
  }

  getHoldTaskPopupTitle(): string {
    if (this.holdTask && this.holdStatusNames.includes(this.holdTask.status)) {
      return 'Release Task';
    }
    return 'Hold Task';
  }

  getContextMenuItems(e: any) {
    if (!this.rowSelectionChanged) {
      this.selectedRowKeys.length = 0;
      this.selectedRowData.length = 0;

      this.selectedRowKeys.push(e.row.data.id);
      this.selectedRowData.push(e.row.data);
    }
    console.log('Selected Row Data:', this.selectedRowData);
    console.log('this.isInitiationTask', this.isInitiationTask());
    console.log('this.hasSubTasks', this.hasSubTasks());
    console.log('this.isUserInTaskTeam', this.isUserInTaskTeam());
    console.log('this.isCompleted', this.isCompleted());
    console.log('this.isRejected', this.isRejected());
    console.log('this.isAssignedToCurrentUser', this.isAssignedToCurrentUser());
    console.log('this.isBatchTask', this.isBatchTask());


    e.items = [
      {
        key: this.assign,
        text: 'Assign To Me',
        icon: 'user',
        disabled:
          this.isInitiationTask() ||
          this.hasSubTasks() ||
          (!this.isUserInTaskTeam() && !this.isEuSubtaskAssignmentBypass()) ||
          this.isCompleted() ||
          this.isRejected() ||
          this.isAssignedToCurrentUser(),
        onItemClick: async () => {
          try {
            this.isLoading = true;
            const response = await lastValueFrom(
              assignTaskToMe(this.selectedRowKeys, this.taskDataService)
            );
            if (response) {
              this.clearSelectedRows();
              this.dataGridTasks.getDataSource()?.reload();
            }
            this.isLoading = false;
          } catch (error: any) {
            this.isLoading = false;
            this.clearSelectedRows();
            notify(error.message, 'error', getNotificationTimeout());
            this.loggingService.logError(error, SeverityLevel.Error);
          }
        },
      },
      {
        key: this.assignToUser,
        text: 'Assign To User',
        icon: 'card',
        disabled:
          this.isInitiationTask() ||
          this.hasSubTasks() ||
          (!this.isUserInTaskTeam() && !this.isEuSubtaskAssignmentBypass()) ||
          this.isCompleted() ||
          this.isRejected(),
        onItemClick: () => {
          if (e.row.data.team != null) {
            this.showUserLookUp(e.row.data);
          }
        },
      },
      {
        key: this.hold,
        text: this.isHeld() ? 'Release' : 'Hold',
        icon: this.isHeld() ? 'taskcomplete' : 'taskstop',
        disabled:
          !this.isAssignedToCurrentUser() ||
          (!this.isOpen() && !this.isHeld()) ||
          this.isParentTask(),
        onItemClick: () => {
          this.holdTask = this.selectedRowData[0];
          this.holdTaskPopupVisible = true;
        },
      },
      {
        key: this.cancel,
        text: 'Cancel',
        icon: 'remove',
        disabled:
          (this.isSubTask() || (!this.isUserInTeam('Task Cancelling') && !this.userIsCreator())) ||
          this.isCompleted() || this.isRejected(),
        onItemClick: () => {
          this.showCommentsVisible = true;
        },
        visible: !this.isSubTask(),
      },
      {
        key: this.complete,
        text: 'Complete',
        icon: 'check',
        visible: !(e.row.data.parentId == null
                   && Array.isArray(e.row.data.subTasks)
                   && e.row.data.subTasks.length > 0),
        disabled:
          this.hasSubTasks() ||
          !this.isUserInTaskTeam() ||
          this.isCompleted() ||
          this.isPending() ||
          !this.isAssignedToCurrentUser() ||
          this.isRejected() || this.isOnHold(),
        onItemClick: async () => {
          await this.applyBulkStatusAction(this.complete);
        },
      },
      {
        key: this.notApplicable,
        text: 'N/A',
        icon: 'check',
        visible: !this.hasSubTasks(),
        disabled:
          this.hasSubTasks() ||
          !this.isUserInTaskTeam() ||
          this.isCompleted() ||
          this.isPending() ||
          !this.isAssignedToCurrentUser() ||
          this.isRejected() || this.isOnHold(),
        onItemClick: async () => {
          await this.applyBulkStatusAction(this.notApplicable);
        },
      },
      {
        key: this.editTask,
        text: 'Edit',
        icon: 'edit',
        disabled:
          // (!this.isAssignedToCurrentUser() && !this.isUserInInitiationTaskEditTeam()) ||
          (!this.userIsCreator() && !this.isUserInInitiationTaskEditTeam()) ||
          !this.isAssignedToCurrentUser() ||
          !this.isOpen() ||
          this.isParentTask() ||
          this.isRejected() ||
          (!this.isInitiationTask() && !this.isBatchTask()),
        onItemClick: () => {
          this.loggingService.logPageView('Edit Task');
          this.onEditTask();
        },
      },
      {
        key: this.redo,
        text: 'Reject',
        icon: 'revert',
        disabled:
          this.isBulkSelection() ||
          !this.isAssignedToCurrentUser() ||
          !this.isOpen() ||
          this.isParentTask() ||
          this.isRejected() ||
          this.isFirstTask(),
        onItemClick: () => {
          this.findTasksToReject();
        },
      },
      {
        key: this.goToParent,
        text: 'Go To Parent',
        icon: 'parentfolder',
        disabled: this.isBulkSelection() || this.isParentTask(),
        onItemClick: () => {
          this.goToParentTask();
        },
      },
      {
        key: this.goToBatch,
        text: 'Go To Batch',
        icon: 'parentfolder',
        disabled: !this.canGoToBatch() || this.isBulkSelection(),
        onItemClick: () => {
          this.openBatchWindow();
        },
      },
    ];
  }

  onEditTask() {
    if (this.isBatchTask()) {
      this.openBatchWindow();
    } else {
      this.selectedTaskSubject$.next(this.selectedRowData[0]);
      this.createOrEditTask(this.selectedRowData[0].workflow, true); //need to do stuff for dynamic forms as workflow not correct in this case
    }
  }

  onRejectTasksClosing(e: any) {
    this.rejectTasksPopupVisible = false;
  }

  onHoldTaskClosing(e: any) {
    this.holdTaskPopupVisible = false;
  }

  async openBatchWindow() {
    const taskId = this.selectedRowData[0]?.taskId;
    const taskName = this.selectedRowData[0]?.name;
    const metadataId = this.selectedRowData[0]?.taskGenerationMetadataId;
    console.log('Opening Batch Window for Task:', taskId, 'Name:', taskName, 'Metadata ID:', metadataId);
    if (!metadataId) {
      return;
    }

    try {
      this.isLoading = true;
      const response = await lastValueFrom(
        this.taskDataService.getGenerateTaskMetadata(metadataId)
      );
      const metadata = response[1] ?? response;
      console.log('Batch Edit Metadata:', metadata);
      this.taskMetadata = {
        taskId,
        taskName,
        taskGenerationMetadataId: metadataId,
        ...metadata,
      };

      this.createOrEditTask('Financial and Compliance');
    } catch (error: any) {
      notify(error.message, 'error', getNotificationTimeout());
      this.loggingService.logError(error, SeverityLevel.Error);
    } finally {
      this.isLoading = false;
    }
  }

  async findTasksToReject() {
    if (this.selectedRowData != null && this.selectedRowData.length != 1)
      return;

    this.rollbackTasks.length = 0;

    try {
      const data = await lastValueFrom(
        this.taskDataService.getTaskById(this.selectedRowData[0].parentId)
      );

      this.rollbackTasks = data[1].subTasks
        .filter(
          (x: ITaskResponse) =>
            x.status != 'Pending' &&
            x.status != 'Open' &&
            x.status != 'In Progress' &&
            x.status != 'Rejected' &&
            x.status != 'Cancelled'
        )
        .sort((a, b) => a.sequenceNumber - b.sequenceNumber);
      this.rejectTasksPopupVisible = true;
    } catch (error: any) {
      notify(error.message, 'error', getNotificationTimeout());
      this.loggingService.logError(error, SeverityLevel.Error);
    }
  }

  async goToParentTask() {
    if (this.selectedRowData != null && this.selectedRowData.length === 1) {
      const selectedTask = this.selectedRowData[0];
      const parentId = selectedTask.parentId;

      if (!parentId) {
        console.warn('goToParentTask - No parent ID found for task:', selectedTask.taskId);
        notify('This task has no parent task', 'warning', getNotificationTimeout());
        return;
      }

      const parent = await this.applyParentTaskFilter(parentId);
      if (parent) {
        // Expand the parent row so the detail sub-grid is visible
        setTimeout(() => {
          this.dataGridTasks.dataGrid.instance.expandRow(parent.parentRowId);
        }, 0);
      }
    }
  }

  // Shared by "Go To Parent" and notification-linked subtasks to filter the grid down to the parent task.
  // Reloads the grid datasource before resolving, so callers can safely act (e.g. expand a row) afterwards.
  private async applyParentTaskFilter(
    parentId: string
  ): Promise<{ parentTaskId: string; parentRowId: string } | null> {
    try {
      const data = await lastValueFrom(this.taskDataService.getTaskById(parentId));

      if (!data || !data[1]) {
        console.warn('applyParentTaskFilter - No data returned from API');
        notify('Parent task not found', 'warning', getNotificationTimeout());
        return null;
      }

      const parentTaskId = data[1].taskId;
      const parentRowId = data[1].id;

      this.dataGridTasks.dataGrid.instance.clearSelection();
      this.dataGridTasks.dataGrid.instance.clearFilter();

      // Navigating to a parent task means we are no longer in the "Subtasks with Attachments" view.
      if (this.isSubtasksWithAttachmentsSelected) {
        this.isSubtasksWithAttachmentsSelected = false;
      }

      this.taskNavigationFilterParameters = {
        taskIds: [parentTaskId],
        filterTypeMessage: `Filtered by task ${parentTaskId}`,
      };
      this.filteredExternallyMessage = this.taskNavigationFilterParameters.filterTypeMessage;
      this.filteredByDashboardTaskIds = true;
      this.resetFilters = false;

      // Show chat/documents buttons in the filtered parent view
      this.isNavigatedToParent = true;
      this.getDataGridButtons();

      await this.dataGridTasks.getDataSource()?.reload();

      return { parentTaskId, parentRowId };
    } catch (error: any) {
      console.error('applyParentTaskFilter - Error:', error);
      notify(error.message, 'error', getNotificationTimeout());
      this.loggingService.logError(error, SeverityLevel.Error);
      return null;
    }
  }

  onReject(body: any) {
    let dialog = custom(
      getDialogYesNoOptions(
        'Reject Task',
        `This action will rollback to ${body.task.taskId}. Do you want to continue?`
      )
    );
    dialog.show().then((result) => {
      if (result) {
        this.rejectSelectedTasks(body);
      } else {
        this.isLoading = false;
      }
    });
  }

  onHold(body: any) {
    // Check if we're releasing (task is currently in a blocked status)
    const isReleasing = this.holdStatusNames.includes(body.task.status);

    let dialogTitle: string;
    let dialogMessage: string;

    if (isReleasing) {
      dialogTitle = 'Release Task';
      dialogMessage = `This action will release task ${body.task.taskId}. Do you want to continue?`;
    } else {
      dialogTitle = 'Hold Task';
      dialogMessage = `This action will hold task ${body.task.taskId} with reason: ${body.status}. Do you want to continue?`;
    }

    let dialog = custom(
      getDialogYesNoOptions(dialogTitle, dialogMessage)
    );
    dialog.show().then((result) => {
      if (result) {
        this.holdSelectedTask(body);
      } else {
        this.isLoading = false;
      }
    });
  }

  async rejectSelectedTasks(body: any) {
    try {
      this.isLoading = true;

      // Clean the task data to remove circular references
      const cleanedTasks = this.selectedRowData.map((task) => {
        const cleanTask = this.cleanTaskDataForApi(task);
        cleanTask.action = 'Reject';
        cleanTask.redoTaskId = body.task.id;
        cleanTask.comments = [
          {
            taskId: cleanTask.id,
            headline: 'Reject Task',
            comment: body.comment,
            createdBy: localStorage.getItem('loggedInUser'),
            createdOn: new Date(),
          },
        ];

        // Append rejectReason to taskData
        if (body.rejectReason) {
          try {
            let taskData = cleanTask.taskData ? JSON.parse(cleanTask.taskData) : {};
            taskData.rejectReason = body.rejectReason;
            cleanTask.taskData = JSON.stringify(taskData);
          } catch (parseError) {
            // If taskData is not valid JSON, create a new object with rejectReason
            this.loggingService.logError(parseError, SeverityLevel.Warning);
            cleanTask.taskData = JSON.stringify({ rejectReason: body.rejectReason });
          }
        }

        return cleanTask;
      });

      const response = await lastValueFrom(
        this.taskDataService.updateTasks(cleanedTasks)
      );

      if (response) {
        // Post comment separately only if there are mentions for users other than the assigned user
        if (body.comment && body.comment.trim().length > 0 && body.mentions && body.mentions.length > 0) {
          // Get the assigned user email from the task we're resetting to
          const assignedUserEmail = body.task.assignedTo?.email;

          // Filter out the assigned user from mentions
          const mentionsToNotify = assignedUserEmail
            ? body.mentions.filter((email: string) => email.toLowerCase() !== assignedUserEmail.toLowerCase())
            : body.mentions;

          // Only make the separate comment post if there are other users to notify
          if (mentionsToNotify.length > 0) {
            const taskIdToUse = body.task.parentId ? body.task.parentId : body.task.id;
            const commentPost = new TaskCommentPost();
            commentPost.taskId = taskIdToUse;
            commentPost.headline = taskIdToUse;
            commentPost.comment = body.comment;
            commentPost.commenterId = localStorage.getItem('loggedInUserId');
            commentPost.mentions = mentionsToNotify;
            commentPost.logEntryTypeId = '';
            commentPost.actionDate = new Date();

            try {
              await lastValueFrom(this.taskDataService.postComment(commentPost));
            } catch (commentError: any) {
              // Log the error but don't fail the entire reject operation
              this.loggingService.logError(commentError, SeverityLevel.Error);
              notify('Task rejected but mention notification failed to send', 'warning', getNotificationTimeout());
            }
          }
        }

        this.rowSelectionChanged = false;
        this.clearSelectedRows();
        this.dataGridTasks.getDataSource()?.reload();
      }

      this.isLoading = false;
      this.rejectTasksPopupVisible = false;
    } catch (error: any) {
      this.isLoading = false;
      notify(error.message, 'error', getNotificationTimeout());
      this.loggingService.logError(error, SeverityLevel.Error);
    }
  }

  async holdSelectedTask(body: any) {
    try {
      this.isLoading = true;

      // Clean the task data to remove circular references, and apply Hold/Release to every
      // selected task rather than only the one the popup was opened from.
      const cleanedTasks = this.selectedRowData.map((task) => {
        const cleanTask = this.cleanTaskDataForApi(task);

        // Check if we're unblocking (task is currently in a blocked status)
        const isUnblocking = this.holdStatusNames.includes(cleanTask.status);

        if (isUnblocking) {
          // Unblocking: change status back to Open
          cleanTask.action = 'Release';
          cleanTask.status = 'Open';
          cleanTask.comments = [
            {
              taskId: cleanTask.id,
              headline: 'Release Task',
              comment: body.comment ? `Task released: ${body.comment}` : 'Task released',
              createdBy: localStorage.getItem('loggedInUser'),
              createdOn: new Date(),
            },
          ];
        } else {
          // Blocking: change status to the selected blocked status
          cleanTask.action = 'Hold';
          cleanTask.status = body.status;
          cleanTask.comments = [
            {
              taskId: cleanTask.id,
              headline: 'Hold Task',
              comment: `Task held - ${body.status}: ${body.comment}`,
              createdBy: localStorage.getItem('loggedInUser'),
              createdOn: new Date(),
            },
          ];
        }

        return cleanTask;
      });

      const response = await lastValueFrom(
        this.taskDataService.updateTasks(cleanedTasks)
      );
      if (response) {
        this.rowSelectionChanged = false;
        this.clearSelectedRows();
        this.dataGridTasks.getDataSource()?.reload();
      }

      this.isLoading = false;
      this.holdTaskPopupVisible = false;
    } catch (error: any) {
      this.isLoading = false;
      notify(error.message, 'error', getNotificationTimeout());
      this.loggingService.logError(error, SeverityLevel.Error);
    }
  }

  // Shared by the Complete and N/A context-menu actions to apply the action to every
  // selected (guaranteed-open) task in a single bulk request, instead of only the clicked row.
  private async applyBulkStatusAction(action: string) {
    try {
      this.isLoading = true;
      const cleanedTasks = this.selectedRowData.map((task) => {
        const cleanTask = this.cleanTaskDataForApi(task);
        cleanTask.action = action;
        return cleanTask;
      });
      const response = await lastValueFrom(
        this.taskDataService.updateTasks(cleanedTasks)
      );
      if (response) {
        this.clearSelectedRows();
        this.dataGridTasks.getDataSource()?.reload();
      }
      this.rowSelectionChanged = false;
      this.isLoading = false;
    } catch (error: any) {
      this.isLoading = false;
      notify(error.message, 'error', getNotificationTimeout());
      this.loggingService.logError(error, SeverityLevel.Error);
    }
  }

  onCommentClosing(e: any) {
    this.showCommentsVisible = false;
  }

  onCancelTasks(body: any) {
    if (this.selectedRowKeys.length > 1) {
      let dialog = custom(
        getDialogYesNoOptions(
          'Cancel Tasks',
          'This will cancel all selected tasks. Do you want to continue?'
        )
      );
      dialog.show().then((result) => {
        if (result) {
          this.cancelTasks(body);
        } else {
          this.rowSelectionChanged = true;
          this.showCommentsVisible = false;
        }
      });
    } else {
      this.cancelTasks(body);
    }
  }

  async cancelTasks(body: any) {
    try {
      this.isLoading = true;

      // Clean the task data to remove circular references
      const cleanedTasks = this.selectedRowData.map((task) => {
        const cleanTask = this.cleanTaskDataForApi(task);
        cleanTask.action = 'Cancel';
        cleanTask.comments = [
          {
            taskId: cleanTask.id,
            headline: 'Cancel Task',
            comment: body.comment,
            createdBy: localStorage.getItem('loggedInUser'),
            createdOn: new Date(),
          },
        ];
        return cleanTask;
      });

      const response = await lastValueFrom(
        this.taskDataService.updateTasks(cleanedTasks)
      );
      if (response) {
        this.rowSelectionChanged = false;
        this.clearSelectedRows();
        this.showCommentsVisible = false;
        this.dataGridTasks.getDataSource()?.reload();
      }
    } catch (error: any) {
      this.isLoading = false;
      notify(error.message, 'error', getNotificationTimeout());
      this.loggingService.logError(error, SeverityLevel.Error);
    }
  }

  clearSelectedRows() {
    this.selectedRowKeys.length = 0;
    this.selectedRowData.length = 0;
    this.dataGridTasks.dataGrid.instance.clearSelection();
    if (this.activeDetailGridInstance) {
      this.activeDetailGridInstance.clearSelection();
      this.activeDetailGridInstance = null;
    }
  }

  async showUserLookUp(rowData: any) {
    try {
      if(rowData.isTeamBound && rowData.team) {//task is team bound so get users for that team only
        const data = await lastValueFrom(
          this.profileDataService.getUsersByGroup([rowData.team])
        );
        this.teamUsers = data[1].flatMap((item) => item.users);
      } else {//task is not team bound so get all users
        const data = await lastValueFrom(
          this.profileDataService.getAllUsers(false)
        );
        this.teamUsers = data[1].map(item => ({ id: item.id, name: item.firstName.trim() + ' ' + item.lastName.trim() }));
      }

    } catch (error: any) {
      this.loggingService.logError(error, SeverityLevel.Error);
    }
    this.assignedUserPopupVisible = true;
  }

  async onAssignedUserSelected(e: any) {
    try {
      this.isLoading = true;
      const response = await lastValueFrom(
        this.taskDataService.assignTaskToUser(e.value.id, this.selectedRowKeys)
      );
      if (response) {
        this.clearSelectedRows();
        this.dataGridTasks.getDataSource()?.reload();
      }
    } catch (error: any) {
      this.isLoading = false;
      this.loggingService.logError(error, SeverityLevel.Error);
      notify(error.message, 'error', getNotificationTimeout());
    }
    this.assignedUserPopupVisible = false;
  }

  private isExpanded: boolean = false;

  onRowClick(e: any) {
    // If a grid button (e.g. the chat icon) was just clicked, its handler
    // already called openDrawer with the correct section. Skip this row-click
    // so it doesn't reset selectedSectionIndex back to 0.
    if (this.buttonClicked) return;
    if (!this.isDrawerOpen) return;

    if (e.rowType == 'group') {
      this.isExpanded = e.isExpanded;
      this.isDrawerOpen = false;
    } else {
      this.isTaskDetailLoadedSubject$.next(false);
      this.selectedRowData.length = 0;
      this.selectedRowData.push(e.data);
      this.selectedSectionIndex = 0;
      this.openDrawer(e);
    }
  }

  onRowDblClick(e: any) {
    if (e.rowType == 'group') {
      this.isExpanded = e.isExpanded;
      this.isDrawerOpen = false;
    } else {
      this.isTaskDetailLoadedSubject$.next(false);
      this.selectedRowData.length = 0;
      this.selectedRowData.push(e.data);
      this.selectedSectionIndex = 0;
      this.openDrawer(e);
    }
  }

  onDetailRowClick(e: any) {
    if (!this.isDrawerOpen) return;

    e.data.parentTaskId = e.data.masterDetails.taskId;
    e.data.parentUrls = e.data.masterDetails.urls;

    this.selectedRowData.length = 0;
    this.selectedRowData.push(e.data);

    this.openDrawer(e);
  }

  onDetailRowDblClick(e: any) {
    e.data.parentTaskId = e.data.masterDetails.taskId;
    e.data.parentUrls = e.data.masterDetails.urls;

    this.selectedRowData.length = 0;
    this.selectedRowData.push(e.data);

    this.selectedSectionIndex = 0;
    this.openDrawer(e);
  }

  openDrawer(e: any) {
    if (
      (this.isCreator() || this.isUserInTaskTeam()) &&
      !this.isCompleted() &&
      !this.isPending() &&
      !this.isRejected()
    ) {
      this.isEditableSubject$.next(true);
    } else {
      this.isEditableSubject$.next(false);
    }

    if (
       !this.isOnHold() && this.isAssignedToCurrentUser() &&
      (!this.isParentTask() || this.isStandaloneTask()) &&
      this.isEditable
    ) {
      this.isCompleteableSubject$.next(true);
    } else {
      this.isCompleteableSubject$.next(false);
    }

    this.isDrawerOpen = true;
    this.selectedTaskSubject$.next(null);
    this.selectedTaskSubject$.next(e.data);
  }

  closePanel() {
    this.isDrawerOpen = false;
    this.selectedTaskSubject$.next(null);
  }

  positionTaskDrawerOverlay(): void {
    const drawerElement = document.querySelector('[data-testid="tasks-drawer"]');
    const overlayWrapper = drawerElement?.closest('.dx-overlay-wrapper') as HTMLElement | null;
    if (!overlayWrapper) {
      return;
    }

    overlayWrapper.style.setProperty('position', 'fixed', 'important');
    overlayWrapper.style.setProperty('top', '56px', 'important');
    overlayWrapper.style.setProperty('bottom', '40px', 'important');
    overlayWrapper.style.setProperty('height', 'auto', 'important');
    overlayWrapper.style.setProperty('transform', 'none', 'important');

    const overlayContent = overlayWrapper.querySelector('.dx-overlay-content') as HTMLElement | null;
    overlayContent?.style.setProperty('height', '100%', 'important');
  }

  constructor(
    private readonly taskDataService: TaskDataService,
    private readonly profileDataService: ProfileDataService,
    private readonly signalRService: SignalRService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly ref: ChangeDetectorRef,
    private readonly loggingService: LoggingService,
    private readonly filterStateService: FilterStateService,
    private readonly featureFlagsService: FeatureFlagsService,
    private readonly destroyRef: DestroyRef
  ) {
    this.findTasksToReject = this.findTasksToReject.bind(this);
    this.rejectSelectedTasks = this.rejectSelectedTasks.bind(this);
    this.holdSelectedTask = this.holdSelectedTask.bind(this);

    if (router.getCurrentNavigation()?.extras.state != null) {
      this.taskNavigationFilterParameters =
        router.getCurrentNavigation()?.extras.state;

      this.filteredExternallyMessage =
        this.taskNavigationFilterParameters.filterTypeMessage ||
        'Filtered by external selection';
      this.filteredByDashboardTaskIds = true;
      this.resetFilters = true;
    }

    this.onMyTasksChanged = this.onMyTasksChanged.bind(this);
    this.onAssignedUserSelected = this.onAssignedUserSelected.bind(this);

    this.isEditable$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: boolean) => {
      this.isEditable = data;
    });

    this.isCompleteable$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: boolean) => {
      this.isCompleteable = data;
    });

    this.isTaskDetailLoaded$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: boolean) => {
      this.isTaskDetailLoaded = data;
    });

    this.selectedTask$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: ITaskResponse) => {
      this.selectedTask = data;
    });

    this.showCompleted$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: boolean) => {
      this.showCompleted = data;
    });

    this.showRejected$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: boolean) => {
      this.showRejected = data;
    });

    // Filter initialization is now handled in ngOnInit() via initializeFilterState()

    taskDataService.getTaskTemplates(true).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((rd: any) => {
      const key = 'templateType';
      // API returns { message, result: [...] } → _.values() → [msg, array]
      const templates = Array.isArray(rd[1]) ? rd[1] : (Array.isArray(rd[0]) ? rd[0] : []);
      const filteredTemplates = templates.filter((item) => item.showTemplateInUi === true);

      const allTemplates = [
        ...new Map(filteredTemplates.map((item) => [item[key], item])).values(),
      ];

      this.taskTemplates = allTemplates.sort((a, b) => a['templateType'].localeCompare(b['templateType']));
    });

    profileDataService.getAllUsers(false).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((rd: any) => {
      this.userData = rd[1];
    });

    taskDataService.getDeals().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((rd: any) => {
      this.deals = Array.isArray(rd[1]) ? rd[1] : [];
    });

    // Don't load task data here anymore - wait for statuses to be loaded in ngOnInit
    // this.LoadTaskData();

    this.sharepointRootUrl =
      environment.sharePoint_Url + '/Shared Documents/General/';

    //subscribe to signalR for task updates / creation /deletion
    this.setupSignalRSubscriptions();

    // Populate columns now so the *ngIf guard in data-grid.component.html is true
    // on Angular's first render, letting DevExtreme initialize with headers in place.
    this.selectedView = this.normalizeSelectedView(localStorage.getItem(this.selectedViewKey));
    this.setTaskGridColumnData();
  }

  private setupSignalRSubscriptions() {
    this.signalRService.taskCreated$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      if (data) {
        this.handleTaskCreated(data);
      }
    });

    this.signalRService.taskChanged$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      if (data) {
        this.handleTaskChanged(data);
      }
    });

    this.signalRService.taskDeleted$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      if (data) {
        this.handleTaskDeleted(data);
      }
    });

    this.signalRService.unreadCountsUpdated$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      if (data) {
        this.handleUnreadCountsUpdated(data);
      }
    });
  }

  private handleTaskCreated(data: any) {
    // console.group('🔔 Task Created Event Received');
    // console.log('📋 Raw data:', data);
    // console.log('🕐 Timestamp:', new Date().toISOString());
    // console.groupEnd();

    // Check if conditions are met for inserting the new task
    const gridInstance = this.dataGridTasks.dataGrid.instance;
    const visibleRows = gridInstance
      .getVisibleRows()
      .filter((row) => row.rowType === 'data');

    // Condition 1: Check if there are more than one task displayed
    if (visibleRows.length <= 1) {
      console.log(
        '❌ Not inserting task: Less than or equal to 1 task displayed'
      );
      return;
    }

    // Condition 2: Check if task due date is within selected date range
    if (this.selectedDateRange && this.selectedDateRange.text !== 'All') {
      data.forEach((taskData) => {
        const taskDueDate = new Date(taskData.task.dueDate);
        const rangeStartDate = this.selectedDateRange.startDate
          ? new Date(this.selectedDateRange.startDate)
          : null;
        const rangeEndDate = this.selectedDateRange.endDate
          ? new Date(this.selectedDateRange.endDate)
          : null;

        // Check if task due date is outside the selected range
        const isOutsideRange =
          (rangeStartDate && taskDueDate < rangeStartDate) ||
          (rangeEndDate && taskDueDate > rangeEndDate);

        if (isOutsideRange) {
          console.log(
            `❌ Not inserting task ${
              taskData.task.taskId
            }: Due date ${taskDueDate.toDateString()} is outside selected range`
          );
          return;
        }
      });
    }

    // Condition 3: Check if datagrid is on page 1
    const currentPageIndex = gridInstance.pageIndex();
    if (currentPageIndex !== 0) {
      console.log(
        `❌ Not inserting task: DataGrid is on page ${
          currentPageIndex + 1
        }, not page 1`
      );
      return;
    }

    data.forEach((element) => {
      const newTaskId = element.task.taskId;
      const newTaskPrefix = newTaskId.substring(0, 4);

      // Check if task type filters are applied
      const hasTaskTypeFilter = Array.from(this.taskFilters.values()).some(
        filter => Array.isArray(filter) && filter[0] === 'taskField'
      );

      // Only check for matching prefix if task type filters are applied
      // If no task type filters, always add the task
      let shouldAddTask = !hasTaskTypeFilter;

      if (hasTaskTypeFilter) {
        // Check if first four letters match any existing task
        const matchingTask = visibleRows.find((row) => {
          const existingTaskId = row.data?.taskId;
          return (
            existingTaskId &&
            existingTaskId.length >= 4 &&
            existingTaskId.substring(0, 4) === newTaskPrefix
          );
        });
        shouldAddTask = !!matchingTask;
      }

      if (shouldAddTask) {
        console.log(
          hasTaskTypeFilter
            ? `✅ Inserting task: Found matching prefix "${newTaskPrefix}"`
            : `✅ Inserting task: No task type filter applied, adding "${newTaskId}"`
        );
        // Force the grid to show the new task by temporarily modifying visible data
        const gridInstance = this.dataGridTasks.dataGrid.instance;

        // Deferred if a column reorder/resize drag is in progress, so this doesn't abort it.
        this.dataGridTasks.runGridUpdate(() => {
          // Get the current visible rows and inject the new task
          const visibleData = gridInstance
            .getVisibleRows()
            .map((row) => row.data)
            .filter((data) => data);
          visibleData.unshift(element.task); // Add new task at the beginning

          // Temporarily replace the data source to show the new task
          gridInstance.beginUpdate();
          const originalDataSource = gridInstance.option('dataSource');
          gridInstance.option('dataSource', visibleData);
          gridInstance.endUpdate();

          // After a brief moment, restore the original data source and refresh
          setTimeout(() => {
            this.dataGridTasks.runGridUpdate(() => {
              gridInstance.option('dataSource', originalDataSource);
              this.refreshGridSilently(gridInstance);
            });
          }, 100);
        });
      } else {
        console.log(
          hasTaskTypeFilter
            ? `❌ Not inserting task: No matching prefix "${newTaskPrefix}" found in filtered view`
            : `❌ Not inserting task: This should not happen when no filters are applied`
        );
      }
    });
  }

  /** Refreshes the grid without showing the page-level loading overlay for this one reload. */
  private refreshGridSilently(gridInstance: any): void {
    this.isSilentGridRefresh = true;
    gridInstance.refresh();
  }

  private handleTaskChanged(data: any) {
    // console.group('🔔 Task Update Event Received');
    // console.log('📋 Raw data:', data);
    // console.log('🕐 Timestamp:', new Date().toISOString());
    // console.groupEnd();

    this.findAndUpdateOrDeleteTask(data);
  }

  private handleTaskDeleted(data: any) {
    // console.group('🔔 Task Deleted Event Received');
    // console.log('📋 Raw data:', data);
    // console.log('🕐 Timestamp:', new Date().toISOString());
    // console.groupEnd();

    this.findAndUpdateOrDeleteTask(data, true);
  }

  private handleUnreadCountsUpdated(data: any) {
    // console.group('🔔 Unread Counts Updated Event Received');
    // console.log('📋 Raw data:', data);
    // console.log('🕐 Timestamp:', new Date().toISOString());
    // console.groupEnd();

    // Update the unread counts for the specific task
    this.updateTaskUnreadCounts(data);
  }

  private updateTaskUnreadCounts(unreadCounts: any) {
    if (!unreadCounts || !unreadCounts.taskId) {
      console.warn('⚠️ Invalid unread counts data received');
      return;
    }

    const gridInstance = this.dataGridTasks.dataGrid.instance;
    const visibleRows = gridInstance.getVisibleRows();

    // Search for the task in main rows
    let taskFound = false;
    for (const row of visibleRows) {
      if (row.data && row.data.id === unreadCounts.taskId) {
        // Update the task's unread counts
        row.data.unreadCommentCount = unreadCounts.unreadComments;
        row.data.unreadUrlCount = unreadCounts.unreadUrls;

        // If this is the currently selected task in the drawer, update it too
        if (this.isDrawerOpen && this.selectedTask?.id === unreadCounts.taskId) {
          this.selectedTask.unreadCommentCount = unreadCounts.unreadComments;
          this.selectedTask.unreadUrlCount = unreadCounts.unreadUrls;
        }

        taskFound = true;
        // console.log(`✅ Updated unread counts for task ${unreadCounts.taskId}:`, {
        //   comments: unreadCounts.unreadComments,
        //   urls: unreadCounts.unreadUrls
        // });
        break;
      }

      // Check subtasks if this is a parent task
      if (row.data?.subTasks && Array.isArray(row.data.subTasks)) {
        const subTask = row.data.subTasks.find(st => st.id === unreadCounts.taskId);
        if (subTask) {
          subTask.unreadCommentCount = unreadCounts.unreadComments;
          subTask.unreadUrlCount = unreadCounts.unreadUrls;

          // If this is the currently selected task in the drawer, update it too
          if (this.isDrawerOpen && this.selectedTask?.id === unreadCounts.taskId) {
            this.selectedTask.unreadCommentCount = unreadCounts.unreadComments;
            this.selectedTask.unreadUrlCount = unreadCounts.unreadUrls;
          }

          taskFound = true;
          console.log(`✅ Updated unread counts for subtask ${unreadCounts.taskId}:`, {
            comments: unreadCounts.unreadComments,
            urls: unreadCounts.unreadUrls
          });
          break;
        }
      }
    }

    if (taskFound) {
      // Trigger change detection to update the badges
      this.ref.detectChanges();
    } else {
      console.log(`ℹ️ Task ${unreadCounts.taskId} not found in current grid view`);
    }
  }

  findAndUpdateOrDeleteTask(data: any, deleteTask: boolean = false) {
    if (!this.dataGridTasks?.dataGrid) {
      return;
    }
    data.forEach((element) => {
      // Check if task exists in the current grid data (including subtasks)
      const gridInstance = this.dataGridTasks.dataGrid.instance;
      let existingTask = null;
      let parentTask = null;
      let isSubTask = false;

      // First check visible rows at the main level
      const visibleRows = gridInstance.getVisibleRows();
      existingTask = visibleRows.find(
        (row) => row.data && row.data.id === element.task.id
      );

      // If not found at main level, check subtasks
      if (!existingTask) {
        for (const row of visibleRows) {
          if (
            row.data?.subTasks &&
            Array.isArray(row.data.subTasks)
          ) {
            existingTask = row.data.subTasks.find(
              (subTask) => subTask.id === element.task.id
            );
            if (existingTask) {
              parentTask = row.data;
              isSubTask = true;
              break;
            }
          }
        }
      }

      if (existingTask) {
        if (isSubTask && parentTask) {
          // Update the subtask within the parent task's subTasks array
          const subTaskIndex = parentTask.subTasks.findIndex(
            (subTask) => subTask.id === element.task.id
          );
          if (subTaskIndex !== -1) {
            if (deleteTask) {
              parentTask.subTasks.splice(subTaskIndex, 1);
            } else {
              // Store the old subtask data for comparison
              const oldSubTask = parentTask.subTasks[subTaskIndex];

              // Update the subtask with the new data (includes unreadCommentCount and unreadUrlCount)
              parentTask.subTasks[subTaskIndex] = element.task;

              // Check if this is a SUS task and amount was updated
              const isSUSTask = element.task.taskId?.substring(0, 3).toUpperCase() === 'SUS';
              if (isSUSTask) {
                // Extract amount from the updated subtask
                const newSubtaskAmount = this.extractAmountFromTaskDataFlexible(element.task.taskData);
                const oldSubtaskAmount = this.extractAmountFromTaskDataFlexible(oldSubTask.taskData);

                // Check if amount actually changed
                const amountChanged = newSubtaskAmount?.amount !== oldSubtaskAmount?.amount;

                if (amountChanged && newSubtaskAmount?.amount != null) {
                  // Update parent task's amount to match the most recently updated subtask
                  (parentTask as any).amount = newSubtaskAmount.amount;
                  if (newSubtaskAmount.currency) {
                    (parentTask as any).currency = newSubtaskAmount.currency;
                  }

                  // Also update the parent's taskData if it exists and has an amount field
                  if (parentTask.taskData) {
                    try {
                      const parentTaskDataObj = typeof parentTask.taskData === 'string'
                        ? JSON.parse(parentTask.taskData)
                        : parentTask.taskData;

                      // Find any field with 'amount' in the name and update it
                      const amountKey = Object.keys(parentTaskDataObj).find(
                        key => key.toLowerCase().includes('amount')
                      );

                      if (amountKey) {
                        parentTaskDataObj[amountKey] = newSubtaskAmount.amount;
                        parentTask.taskData = JSON.stringify(parentTaskDataObj);

                        // Refresh prettified data if it exists
                        if (parentTask.prettifiedTaskData || parentTask.prettifiedTaskDataArray) {
                          this.enrichRowData([parentTask]);
                        }
                      }
                    } catch (error) {
                      console.warn('Failed to update parent task amount in taskData:', error);
                    }
                  }
                }
              }

              // If this task is currently selected in the drawer, update it
              if (this.isDrawerOpen && this.selectedTask?.id === element.task.id) {
                this.selectedTaskSubject$.next(element.task);
              }
            }
            // Trigger change detection to update the badge overlay and amount display
            this.ref.detectChanges();
          }
        } else {
          // If this task is currently selected in the drawer, update the
          // detail panel AND repaint only that one grid row in-place.
          // Calling gridInstance.refresh() here would reload ALL data and
          // visually look like a full-page refresh (e.g. after posting a comment).
          if (this.isDrawerOpen && this.selectedTask?.id === element.task.id) {
            this.selectedTaskSubject$.next(element.task);
            Object.assign(existingTask.data, element.task);
            gridInstance.repaintRows([existingTask.rowIndex]);
          } else {
            // Task is not currently open — safe to do a full grid refresh, deferred if a
            // column reorder/resize drag is in progress so it doesn't abort the drag.
            // Marked silent so the background reload never shows the page-level loading overlay.
            this.dataGridTasks.runGridUpdate(() => this.refreshGridSilently(gridInstance));
          }
        }
      }
    });
  }

  private initialiseHeaderFilters() {
    this.radioGroupValue = { Due: null, Scope: null };
    let taskFilter = this.setScope();
    let completed = JSON.parse(localStorage.getItem('showCompleted')) || false;
    let rejected = JSON.parse(localStorage.getItem('showRejected')) || false;

    // Set the component properties to force checkboxes to match initial values
    this.showCompleted = completed;
    this.showRejected = rejected;

    // Also update the BehaviorSubjects in case they are used elsewhere
    this.showCompletedSubject$.next(completed);
    this.showRejectedSubject$.next(rejected);

    this.showCompletedChanged({ value: completed }, false);
    this.showRejectedChanged({ value: rejected }, false);
    // Initialize task scope filter and column configuration
    this.onMyTasksChanged(taskFilter, false);

    this.selectedDateRange = this.setDue();

    this.buildDateFilter(this.selectedDateRange);
  }

  setScope() {
    let scopeIndex = localStorage.getItem(this.myTasksKey) || 2;
    this.radioGroupValue['Scope'] = datePanelItems[1].items[scopeIndex];
    // Initialize the isSubtasksWithAttachmentsSelected property based on stored scope
    this.isSubtasksWithAttachmentsSelected = (scopeIndex == 3);
    return scopeIndex;
  }

  setDue() {
    let dueIndex = localStorage.getItem(this.dateRangeKey) || 4;
    let selectedDateRange = datePanelItems[0].items[dueIndex];
    this.radioGroupValue['Due'] = selectedDateRange;
    return selectedDateRange;
  }

  enrichRowData(rowData: ITaskResponse[]) {
    if (!rowData) return;
    rowData.forEach((row) => {
      (row as any).daysPastDue = this.calculateDaysPastDue((row as any).dueDate);

      if (row.taskTags != null && row.taskTags.length > 0) {
        row.referenceName = this.getTaskTagValue(
          'Reference Name',
          row.taskTags
        );
        row.mandate = this.getTaskTagValue('Mandate Name', row.taskTags);
        row.referenceType = this.getTaskTagValue(
          'Reference Type',
          row.taskTags
        );
      }

      // Extract amount field from taskData - find any field containing 'amount' in its name
      if (row.taskData) {
        // Parse once; pass the object so both helpers skip their own JSON.parse
        let parsedTaskData: any;
        try {
          parsedTaskData = typeof row.taskData === 'string' ? JSON.parse(row.taskData as any) : row.taskData;
        } catch {
          parsedTaskData = row.taskData;
        }

        const extractedAmount = this.extractAmountFromTaskDataFlexible(parsedTaskData);
        if (extractedAmount !== null) {
          (row as any).amount = extractedAmount.amount;
          if (extractedAmount.currency) {
            (row as any).currency = extractedAmount.currency;
          }
        }

        // Also extract other fields using the existing method
        const extractedFields = this.extractFieldsFromTaskData(parsedTaskData, this.taskDataFieldMappings);

        // Assign extracted fields to the row object (but don't overwrite amount if already set)
        Object.keys(extractedFields).forEach(field => {
          const normalizedFieldValue = this.normalizeTaskDataDerivedFieldValue(
            field,
            extractedFields[field]
          );

          if (field !== 'amount' || !(row as any).amount) {
            // taskData.dealName is often a stored deal number/ID rather than the display name
            (row as any)[field] = field === 'dealName'
              ? UtilitiesService.resolveDealName(normalizedFieldValue, this.deals, this.featureFlagsService.isEu())
              : normalizedFieldValue;
          }
        });

        // EU grids label referenceName as Deal Name, so prefer the selected deal
        // over the facility/reference value returned by the task API.
        if (this.featureFlagsService.isEu() && (row as any).dealName) {
          (row as any).referenceName = (row as any).dealName;
        }

        this.populateErfReferenceName(row, parsedTaskData);
      }

      if (row.subTasks != null && row.subTasks.length > 0) {
        // Compute the open subtask names before recursing into subtask enrichment
        (row as any).openSubtask = row.subTasks
          .filter((sub: ITaskResponse) => sub.status?.toLowerCase() === 'open')
          .map((sub: ITaskResponse) => sub.name)
          .join(', ');

        this.enrichRowData(row.subTasks);
      } else {
        (row as any).openSubtask = '';
      }
    });
  }

  private async enrichRowDataAsync(rowData: ITaskResponse[], batchSize = 50): Promise<void> {
    for (let i = 0; i < rowData.length; i += batchSize) {
      const batch = rowData.slice(i, i + batchSize);
      this.enrichRowData(batch);
      await this.hydrateLegacyFacilityDisplayForRows(batch);
      // Yield to the browser event loop between batches to allow paint frames
      await new Promise<void>(resolve => setTimeout(resolve, 0));
    }
  }

  private async hydrateLegacyFacilityDisplayForRows(rows: ITaskResponse[]): Promise<void> {
    if (!Array.isArray(rows) || rows.length === 0) {
      return;
    }

    await Promise.all(rows.map(async (row: any) => {
      await this.hydrateLegacyFacilityDisplay(row);

      if (Array.isArray(row.subTasks) && row.subTasks.length > 0) {
        await this.hydrateLegacyFacilityDisplayForRows(row.subTasks);
      }
    }));
  }

  private async hydrateLegacyFacilityDisplay(row: any): Promise<void> {
    const parsedTaskData = this.parseTaskDataObject(row?.taskData);
    const rawFacilityId = parsedTaskData?.facilityId;
    if (!rawFacilityId || parsedTaskData.facilityIdDisplay) {
      return;
    }

    // dxTagBox stores an array (multi-select); dxSelectBox stores a scalar (legacy single-select)
    const isMultiSelect = Array.isArray(rawFacilityId);
    const facilityIds = isMultiSelect ? rawFacilityId : [rawFacilityId];
    if (isMultiSelect && facilityIds.length === 0) {
      return;
    }

    const displayValues = (
      await Promise.all(facilityIds.map((facilityId: string) => this.resolveLegacyFacilityDisplay(facilityId)))
    ).filter((value): value is string => !!value);
    if (!displayValues.length) {
      return;
    }

    parsedTaskData.facilityIdDisplay = isMultiSelect ? displayValues : displayValues[0];
    row.taskData = JSON.stringify(parsedTaskData);
    this.populateErfReferenceName(row, parsedTaskData);
  }

  private populateErfReferenceName(row: any, taskData: any): void {
    const requestType = String(taskData?.requestType ?? row?.name ?? '').trim().toLowerCase();
    if (requestType !== 'erf request' || row?.referenceName) {
      return;
    }

    const dealNameSource = taskData?.dealName ?? taskData?.facilityIdDisplay;
    const dealName = Array.isArray(dealNameSource)
      ? UtilitiesService.dedupeFacilityDisplayValues(dealNameSource).join(', ')
      : dealNameSource;
    if (typeof dealName === 'string' && dealName.trim()) {
      row.referenceName = dealName.trim();
    }
  }

  private parseTaskDataObject(taskData: any): any | undefined {
    if (!taskData) {
      return undefined;
    }

    if (typeof taskData === 'object') {
      return taskData;
    }

    try {
      return JSON.parse(taskData);
    } catch {
      return undefined;
    }
  }

  private resolveLegacyFacilityDisplay(facilityId: string): Promise<string | undefined> {
    const cacheKey = String(facilityId);
    const cachedDisplay = this.facilityDisplayCache.get(cacheKey);
    if (cachedDisplay) {
      return cachedDisplay;
    }

    const displayLookup = lastValueFrom(this.taskDataService.getLoanDetail(cacheKey)).then((response: any) => {
      const loanDetail = Array.isArray(response?.[1])
        ? response[1][0] ?? null
        : response?.[1] ?? null;
      const displayValue = loanDetail?.loanNumberRef ?? loanDetail?.LoanNumberRef ?? loanDetail?.name ?? loanDetail?.displayName;
      return typeof displayValue === 'string' && displayValue.trim()
        ? displayValue.trim()
        : undefined;
    }).catch((error) => {
      this.loggingService.logError(error, SeverityLevel.Warning);
      return undefined;
    });

    this.facilityDisplayCache.set(cacheKey, displayLookup);
    return displayLookup;
  }

  private calculateDaysPastDue(dueDateValue: string | Date | null | undefined): number | null {
    if (!dueDateValue) {
      return null;
    }

    const dueDate = new Date(dueDateValue);
    if (isNaN(dueDate.getTime())) {
      return null;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dueDate.setHours(0, 0, 0, 0);

    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    return Math.round((dueDate.getTime() - today.getTime()) / millisecondsPerDay);
  }

  extractFieldsFromTaskData(taskData: string | any, fieldMappings: { [key: string]: string[] }): { [key: string]: any } {
    if (!taskData) return {};

    try {
      const parsedData = typeof taskData === 'string' ? JSON.parse(taskData) : taskData;
      const extractedFields: { [key: string]: any } = {};

      // Pre-build lowercase key map so case-insensitive lookup is O(1) instead of O(n_keys)
      const lowerKeyMap = new Map<string, any>(
        Object.keys(parsedData).map(key => [key.toLowerCase(), parsedData[key]])
      );

      Object.keys(fieldMappings).forEach(targetField => {
        const possibleFieldNames = fieldMappings[targetField];

        for (const fieldName of possibleFieldNames) {
          if (parsedData[fieldName] !== undefined && parsedData[fieldName] !== null) {
            extractedFields[targetField] = parsedData[fieldName];
            break;
          }

          const ciValue = lowerKeyMap.get(fieldName.toLowerCase());
          if (ciValue !== undefined && ciValue !== null) {
            extractedFields[targetField] = ciValue;
            break;
          }
        }
      });

      return extractedFields;
    } catch (error) {
      console.warn('Failed to parse taskData for field extraction:', error);
      return {};
    }
  }

  private normalizeTaskDataDerivedFieldValue(field: string, value: any): any {
    if (value == null) {
      return value;
    }

    if (field === 'borrowerName') {
      if (Array.isArray(value)) {
        return value
          .map((item: any) =>
            typeof item === 'object' && item !== null
              ? item.name ?? item.label ?? item.value ?? String(item)
              : String(item)
          )
          .filter(Boolean)
          .join(', ');
      }

      if (typeof value === 'object') {
        return (value as any).name ?? (value as any).label ?? (value as any).value ?? String(value);
      }

      return value;
    }

    if (this.booleanTaskDataDerivedFields.has(field)) {
      if (typeof value === 'string') {
        const normalizedValue = value.trim().toLowerCase();
        if (normalizedValue === 'true') {
          return true;
        }

        if (normalizedValue === 'false') {
          return false;
        }
      }

      return value;
    }

    if (field === 'voucherDueDate') {
      const parsedDate = new Date(value);
      return isNaN(parsedDate.getTime()) ? value : parsedDate;
    }

    if (field === 'fedReferenceNumbers') {
      if (Array.isArray(value)) {
        return value
          .map((item: any) => (typeof item === 'object' && item !== null ? item.reference : String(item)))
          .filter(Boolean)
          .join(', ');
      }
      return value;
    }

    return value;
  }

  /**
   * Extracts any field containing 'amount' in its name from taskData JSON
   * Returns the first matching amount field and associated currency if available
   */
  extractAmountFromTaskDataFlexible(taskData: string | any): { amount: number | string | null, currency?: string } | null {
    if (!taskData) return null;

    try {
      const parsedData = typeof taskData === 'string' ? JSON.parse(taskData) : taskData;

      // Pre-build lowercase key map for O(1) lookups
      const lowerKeyMap = new Map<string, any>(
        Object.keys(parsedData).map(key => [key.toLowerCase(), parsedData[key]])
      );

      const amountEntry = [...lowerKeyMap.entries()].find(([k]) => k.includes('amount'));

      if (amountEntry && amountEntry[1] !== undefined && amountEntry[1] !== null) {
        const result: { amount: number | string | null, currency?: string } = {
          amount: amountEntry[1]
        };

        for (const currKey of ['currency', 'currencycode', 'ccy']) {
          const ciValue = lowerKeyMap.get(currKey);
          if (ciValue) {
            result.currency = ciValue;
            break;
          }
        }

        return result;
      }

      return null;
    } catch (error) {
      console.warn('Failed to parse taskData for amount extraction:', error);
      return null;
    }
  }

  // Keep the original method as a fallback for backward compatibility
  extractAmountFromTaskData(taskData: string | any): number | string | null {
    const fieldMappings = {
      amount: ['amount', 'requestAmount', 'totalAmount', 'loanAmount', 'drawAmount']
    };
    const extracted = this.extractFieldsFromTaskData(taskData, fieldMappings);
    return extracted['amount'] || null;
  }

  private normalizeValue(value: unknown): string {
    return `${value ?? ''}`.trim().toUpperCase();
  }

  private parseUrgentValue(value: unknown): boolean {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    const normalized = this.normalizeValue(value);
    return normalized === 'TRUE' || normalized === '1' || normalized === 'YES' || normalized === 'Y';
  }

  private getTaskPayload(task: any): any {
    if (!task) {
      return null;
    }

    const payload = task.taskData ?? task.data?.taskData;
    if (!payload) {
      return null;
    }

    if (typeof payload === 'string') {
      try {
        return JSON.parse(payload);
      } catch {
        return null;
      }
    }

    return payload;
  }

  private isUrgentPrimaryServicingPaymentInstruction(task: any): boolean {
    if (!task) {
      return false;
    }

    const taskPayload = this.getTaskPayload(task);

    const workflowCandidates = [
      task.workflow,
      task.taskType,
      task.data?.workflow,
      task.data?.taskType,
      taskPayload?.workflow,
      taskPayload?.taskType,
    ]
      .map((candidate) => this.normalizeValue(candidate))
      .filter(Boolean);

    const requestTypeCandidates = [
      task.name,
      task.requestType,
      task.data?.name,
      task.data?.requestType,
      taskPayload?.requestType,
      taskPayload?.serviceRequestType,
    ]
      .map((candidate) => this.normalizeValue(candidate))
      .filter(Boolean);

    const isPrimaryServicing = workflowCandidates.some(
      (workflow) => workflow.includes('PRIMARY SERVICING') || workflow.includes('SERVICING REQUEST')
    );

    const isPaymentInstruction = requestTypeCandidates.some(
      (requestType) =>
        requestType === 'PAYMENT' ||
        requestType === 'PAYMENT INSTRUCTION' ||
        requestType === 'PAYMENT CHANGE' ||
        requestType === 'PAYMENTCHANGE'
    );

    if (!isPrimaryServicing || !isPaymentInstruction) {
      return false;
    }

    const urgentCandidates = [
      task.isUrgent,
      task.urgent,
      task.data?.isUrgent,
      task.data?.urgent,
      taskPayload?.isUrgent,
      taskPayload?.urgent,
    ];

    return urgentCandidates.some((candidate) => this.parseUrgentValue(candidate));
  }

  getFormattedAmount = (row: any): string => {
    if (!row || (!row.amount && row.amount !== 0)) {
      return '';
    }

    // loanAmounts rows each carry their own amount and currency; show one amount per row
    if (Array.isArray(row.amount)) {
      return row.amount
        .filter((item: any) => item && item.amount !== null && item.amount !== undefined && item.amount !== '')
        .map((item: any) => this.formatAmountWithCurrency(item.amount, item.currency || row.currency))
        .join(', ');
    }

    return this.formatAmountWithCurrency(row.amount, row.currency);
  };

  private formatAmountWithCurrency(rawAmount: any, rowCurrency?: string): string {
    const amount = parseFloat(rawAmount);
    if (isNaN(amount)) {
      return rawAmount?.toString() || '';
    }

    // Get currency from extracted field or default to the region's currency
    const currency = rowCurrency || this.featureFlagsService.getDefaultCurrency();

    // Use Intl.NumberFormat for proper currency formatting with accountancy style
    try {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        currencySign: 'accounting', // Use accounting format (parentheses for negative numbers)
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return formatter.format(amount);
    } catch (error) {
      // Fallback if currency code is invalid
      const fallbackCurrency = this.featureFlagsService.getDefaultCurrency();
      console.warn(`Invalid currency code: ${currency}, using ${fallbackCurrency} as fallback`);
      const fallbackFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: fallbackCurrency,
        currencySign: 'accounting',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return fallbackFormatter.format(amount);
    }
  }

  /**
   * Check if a field has been edited in a task's history
   */
  hasFieldBeenEdited(task: any, fieldKey: string): boolean {
    if (!task) return false;

    // For subtasks in "My Subtasks" view, check both the task's own taskData
    // and potentially inherited data from parent
    if (!task.taskData) {
      // If taskData is missing, try checking task.data or other potential locations
      if (task.data && task.data.taskData) {
        task.taskData = task.data.taskData;
      } else {
        return false;
      }
    }

    try {
      // Parse taskData if it's a string
      const parsedData = typeof task.taskData === 'string' ? JSON.parse(task.taskData) : task.taskData;

      // Check if editedFields array exists and contains this field
      const editedFields = parsedData?.editedFields;
      if (!editedFields || !Array.isArray(editedFields)) return false;

      // Check if any entry in editedFields matches this field name
      return editedFields.some((edit: any) => edit.name === fieldKey);
    } catch (error) {
      console.warn('Failed to parse taskData for field edit check:', error, 'taskId:', task.taskId);
      return false;
    }
  }

  /**
   * Check if a task's amount field should be highlighted based on its prefix and edit history
   */
  shouldHighlightAmount(task: any): boolean {
    if (!task || !task.taskId) {
      return false;
    }

    // Extract the prefix (first 3 characters before the hyphen)
    // For subtasks (e.g., "SUS-123.1"), this will extract "SUS"
    const match = task.taskId.match(/^([A-Z]+)-/);
    if (!match) {
      return false;
    }

    const prefix = match[1];

    // Find matching configuration for this prefix
    const config = this.editableFields.find((item: any) => item.prefix === prefix);
    if (!config) {
      return false;
    }

    // Check if 'amount' is in the editable fields for this prefix
    const hasAmountField = (config as any).fields.some((field: any) =>
      (typeof field === 'string' ? field : field.name) === 'amount'
    );

    if (!hasAmountField) {
      return false;
    }

    // Check if the amount field has been edited
    // For subtasks displayed in "My Subtasks", we need to check the subtask's own edit history
    const hasBeenEdited = this.hasFieldBeenEdited(task, 'amount');
    return hasBeenEdited;
  }

  /**
   * Get CSS class for amount cell based on edit history
   */
  getAmountCellClass = (task: any): string => {
    const shouldHighlight = this.shouldHighlightAmount(task);
    return shouldHighlight ? 'edited-field-highlight' : '';
  }

  getTaskTagValue(key: string, tags: ITaskTag[]) {
    return tags.find((x) => x.key == key)?.value;
  }

  getTestData() {
    return {
      totalCount: 6,
      data: [
        { id: '1', taskId: '1', taskName: 'a' },
        { id: '2', taskId: '2', taskName: 'b' },
        { id: '3', taskId: '3', taskName: 'a' },
        { id: '4', taskId: '4', taskName: 'd' },
        { id: '5', taskId: '5', taskName: 'e' },
        { id: '6', taskId: '6', taskName: 'f' },
      ],
    };
  }

  processTaskDataDerivedFields(loadOptions: LoadOptions) {
    // Handle sorting for taskData-derived fields
    if (loadOptions.sort && Array.isArray(loadOptions.sort)) {
      const updatedSort: any[] = [];

      loadOptions.sort.forEach((sortItem) => {
        // Handle different DevExtreme sort structures
        let selector: string | undefined;
        let desc: boolean | undefined;
        let originalStructure: 'array' | 'object' | 'string' = 'object';

        if (Array.isArray(sortItem) && sortItem[0] && sortItem[0].selector) {
          // Structure: [[{selector: 'field', desc: false}]]
          selector = sortItem[0].selector as string;
          desc = sortItem[0].desc;
          originalStructure = 'array';
        } else if (sortItem && typeof sortItem === 'object' && (sortItem as any).selector) {
          // Structure: [{selector: 'field', desc: false}]
          selector = (sortItem as any).selector as string;
          desc = (sortItem as any).desc;
          originalStructure = 'object';
        } else if (typeof sortItem === 'string') {
          // Structure: ['field']
          selector = sortItem;
          desc = false;
          originalStructure = 'string';
        }

        const taskDataField = selector
          ? this.taskDataDerivedFieldMap[selector]
          : null;

        if (selector && taskDataField) {
          // Transform the selector for taskData fields
          const transformedSelector = `taskData.${taskDataField}`;

          // Maintain the same structure as input
          if (originalStructure === 'array') {
            updatedSort.push([{
              selector: transformedSelector,
              desc: desc
            }]);
          } else if (originalStructure === 'object') {
            updatedSort.push({
              selector: transformedSelector,
              desc: desc
            });
          } else {
            updatedSort.push(transformedSelector);
          }
        } else {
          // Keep original sort for non-taskData fields
          updatedSort.push(sortItem);
        }
      });

      loadOptions.sort = updatedSort;
    }

    // Handle filtering for taskData-derived fields
    if (loadOptions.filter) {
      loadOptions.filter = this.processTaskDataFilters(loadOptions.filter);
    }
  }

  processTaskDataFilters(filter: any): any {
    if (!filter) return filter;

    // If it's an array (compound filter)
    if (Array.isArray(filter)) {
      if (
        filter.length === 3 &&
        typeof filter[0] === 'string' &&
        typeof filter[1] === 'string'
      ) {
        const mappedField = this.taskDataDerivedFieldMap[filter[0]];

        if (mappedField) {
          return [`taskData.${mappedField}`, filter[1], filter[2]];
        }
      }

      return filter.map(item => this.processTaskDataFilters(item));
    }

    // If it's a filter object with selector
    if (filter && typeof filter === 'object' && filter.selector) {
      const mappedField = this.taskDataDerivedFieldMap[filter.selector];

      if (mappedField) {
        // Create a new filter object with taskData prefix
        return {
          ...filter,
          selector: `taskData.${mappedField}`
        };
      }
    }

    // For other filter structures, recursively process
    if (filter && typeof filter === 'object') {
      const processedFilter: any = {};
      Object.keys(filter).forEach(key => {
        processedFilter[key] = this.processTaskDataFilters(filter[key]);
      });
      return processedFilter;
    }

    return filter;
  }

  /**
   * Maps user display names to user IDs for filtering
   * @param nameOrNames Single name or array of names
   * @returns Corresponding userId(s)
   */
  private getUserIdsByName(nameOrNames: string | string[]): string | string[] {
    if (!this.userData || !nameOrNames) return nameOrNames;

    const findUserId = (name: string): string => {
      const user = this.userData.find((u: any) => {
        const fullName = u.lastName?.trim()
          ? `${u.firstName} ${u.lastName}`
          : u.firstName;
        return fullName === name || u.name === name;
      });
      return user?.id || name; // Fallback to name if not found
    };

    if (Array.isArray(nameOrNames)) {
      return nameOrNames.map(findUserId);
    }
    return findUserId(nameOrNames);
  }

  private isRejectedStatus(status: string | null | undefined): boolean {
    return (status || '').toLowerCase() === 'rejected';
  }

  private getRejectionVisibleSubTasks(subTasks: ITaskResponse[]): ITaskResponse[] {
    return this.showRejected
      ? subTasks
      : subTasks.filter((subTask: ITaskResponse) => !this.isRejectedStatus(subTask.status));
  }

  // Parent rows are already filtered server-side; subtasks are nested inside a matched
  // parent's response and must be hidden client-side when Show Rejected is off (#181).
  private applyRejectionVisibilityToSubTasks(taskData: ITaskResponse[]): ITaskResponse[] {
    if (this.showRejected) {
      return taskData;
    }

    return taskData.map((row: ITaskResponse) => {
      if (!Array.isArray(row.subTasks)) {
        return row;
      }

      return {
        ...row,
        subTasks: this.getRejectionVisibleSubTasks(row.subTasks),
      };
    });
  }

  LoadTaskData() {
    const isNotEmpty = (value: unknown) =>
      value !== undefined && value !== null && value !== '';

    this.dataSource = new CustomStore({
      key: 'id',
      load: async (loadOptions: LoadOptions) => {
        // Default paging params — prevents unbounded API queries when the store is
        // created before the grid applies its dxo-paging configuration (#183).
        if (!loadOptions.take) {
          loadOptions.take = 20;
        }
        if (loadOptions.skip == null) {
          loadOptions.skip = 0;
        }

        // Reset immediately so only this one load() call is treated as silent.
        const isSilentLoad = this.isSilentGridRefresh;
        this.isSilentGridRefresh = false;
        if (!isSilentLoad) {
          this.isLoading = true;
        }

        // Handle taskData-derived fields for sorting and filtering
        this.processTaskDataDerivedFields(loadOptions);

        try {
          let response: any = null;
          const viewFilter = this.getSelectedViewFilter();

          if (this.taskNavigationFilterParameters != null) {
            if (this.filteredByDashboardTaskIds) {
              if (this.resetFilters) {
                this.dataGridTasks.dataGrid.instance.clearSelection();
                this.dataGridTasks.dataGrid.instance.clearFilter();
                this.resetFilters = false;
              }
            }

            // Add scope parameter to loadOptions for dashboard navigation requests
            const optionsWithScope = {
              ...loadOptions,
              scope: this.currentScopeName
            };

            if (viewFilter.length > 0) {
              optionsWithScope.filter = optionsWithScope.filter
                ? [viewFilter, 'and', optionsWithScope.filter]
                : viewFilter;
            }

            response = await lastValueFrom(
              this.taskDataService.getMultipleTasksById(
                optionsWithScope,
                this.taskNavigationFilterParameters.taskIds
              )
            );
          } else {
            loadOptions.userData = this.buildTaskFilterArray(
              loadOptions.filter != null
            );

            const orFilters = this.buildOrTasksFilterArray(false);

            // Combine myTeamsTaskFilter and mySubtasksFilter into a single scope filter
            // Only one will be active at a time based on the selected scope
            const scopeFilter: FilterDescriptor =
              this.mySubtasksFilter.length > 0 ? this.mySubtasksFilter :
              this.myTeamsTaskFilter.length > 0 ? this.myTeamsTaskFilter : [];

            // Build scopeParts as a flat list so viewFilter and scopeFilter remain
            // independent 'and' conditions at the same level in the filter chain.
            // Previously, merging them into a nested array created a sub-group.
            const scopeParts: any[] = [];
            if (viewFilter.length > 0) scopeParts.push(viewFilter);
            if (viewFilter.length > 0 && scopeFilter.length > 0) scopeParts.push('and');
            if (scopeFilter.length > 0) scopeParts.push([...scopeFilter]);

            const paramNames = [
              'skip',
              'take',
              'requireGroupCount',
              'sort',
              'filter',
              'totalSummary',
              'group',
              'groupSummary',
              'userData',
              'requireTotalCount',
            ];

            let params = new HttpParams();
            let userDataLoaded = false;

            paramNames
              .filter((paramName) => isNotEmpty(loadOptions[paramName]))
              .forEach((paramName) => {
                //111
                if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length > 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length > 0
                ) {
                  // add user data to the filter
                  let filterData = [loadOptions[paramName]];
                  let filters = [
                    orFilters,
                    'and',
                    ...scopeParts,
                    'and',
                    [loadOptions['userData'], ...filterData],
                  ];
                  params = params.set(paramName, JSON.stringify(filters));
                  userDataLoaded = true;
                } //110
                else if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length > 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length == 0
                ) {
                  // add user data to the filter
                  let filterData = [loadOptions[paramName]];
                  let filters = [
                    orFilters,
                    'and',
                    ...loadOptions['userData'],
                    ...filterData,
                  ];
                  params = params.set(paramName, JSON.stringify(filters));
                  userDataLoaded = true;
                } //101
                else if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length > 0 &&
                  orFilters.length == 0 &&
                  scopeParts.length > 0
                ) {
                  // add user data to the filter
                  let filterData = [loadOptions[paramName]];
                  let filters = [
                    ...scopeParts,
                    'and',
                    [...loadOptions['userData'], ...filterData],
                  ];
                  params = params.set(paramName, JSON.stringify(filters));
                  userDataLoaded = true;
                } //100
                else if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length > 0 &&
                  orFilters.length == 0 &&
                  scopeParts.length == 0
                ) {
                  // add user data to the filter
                  let filterData = [loadOptions[paramName]];
                  let filters = [[...loadOptions['userData'], ...filterData]];
                  params = params.set(paramName, JSON.stringify(filters));
                  userDataLoaded = true;
                } //010
                else if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length == 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length == 0
                ) {
                  // add user data to the filter
                  let filterData = [loadOptions[paramName]];
                  let filters = [orFilters, 'and', [...filterData]];
                  params = params.set(paramName, JSON.stringify(filters));
                  userDataLoaded = true;
                } //011
                else if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length == 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length > 0
                ) {
                  // add user data to the filter
                  let filterData = [loadOptions[paramName]];
                  let filters = [
                    orFilters,
                    'and',
                    ...scopeParts,
                    'and',
                    [...filterData],
                  ];
                  params = params.set(paramName, JSON.stringify(filters));
                  userDataLoaded = true;
                } //001
                else if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length == 0 &&
                  orFilters.length == 0 &&
                  scopeParts.length > 0
                ) {
                  // add user data to the filter
                  let filterData = [loadOptions[paramName]];
                  let filters = [
                    ...scopeParts,
                    'and',
                    ...filterData,
                  ];
                  params = params.set(paramName, JSON.stringify(filters));
                  userDataLoaded = true;
                } else if (
                  paramName == 'filter' &&
                  loadOptions['userData'].length == 0 &&
                  orFilters.length == 0 &&
                  scopeParts.length == 0
                ) {
                  // add user data to the filter
                  params = params.set(
                    paramName,
                    JSON.stringify(loadOptions[paramName])
                  );
                  userDataLoaded = true;
                }
                //001
                else if (
                  paramName == 'userData' &&
                  loadOptions[paramName].length == 0 &&
                  orFilters.length == 0 &&
                  scopeParts.length > 0 &&
                  !userDataLoaded
                ) {
                  params = params.set(
                    'filter',
                    JSON.stringify(scopeParts.length === 1 ? scopeParts[0] : scopeParts)
                  );
                } //011
                else if (
                  paramName == 'userData' &&
                  loadOptions[paramName].length == 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length > 0 &&
                  !userDataLoaded
                ) {
                  params = params.set(
                    'filter',
                    JSON.stringify([
                      orFilters,
                      'and',
                      ...scopeParts,
                    ])
                  );
                } //010
                else if (
                  paramName == 'userData' &&
                  loadOptions[paramName].length == 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length == 0 &&
                  !userDataLoaded
                ) {
                  params = params.set('filter', JSON.stringify([orFilters]));
                }
                //101
                else if (
                  paramName == 'userData' &&
                  loadOptions[paramName].length > 0 &&
                  orFilters.length == 0 &&
                  scopeParts.length > 0 &&
                  !userDataLoaded
                ) {
                  params = params.set(
                    'filter',
                    JSON.stringify([
                      ...scopeParts,
                      'and',
                      ...loadOptions[paramName],
                    ])
                  );
                }
                //110
                else if (
                  paramName == 'userData' &&
                  loadOptions[paramName].length > 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length == 0 &&
                  !userDataLoaded
                ) {
                  params = params.set(
                    'filter',
                    JSON.stringify([
                      orFilters,
                      'and',
                      ...loadOptions[paramName],
                    ])
                  );
                }
                //111
                else if (
                  paramName == 'userData' &&
                  loadOptions[paramName].length > 0 &&
                  orFilters.length > 0 &&
                  scopeParts.length > 0 &&
                  !userDataLoaded
                ) {
                  params = params.set(
                    'filter',
                    JSON.stringify([
                      orFilters,
                      'and',
                      ...scopeParts,
                      'and',
                      loadOptions[paramName],
                    ])
                  );
                } else if (
                  paramName == 'userData' &&
                  loadOptions[paramName].length > 0 &&
                  !userDataLoaded
                ) {
                  params = params.set(
                    'filter',
                    JSON.stringify(loadOptions[paramName])
                  );
                } else if (paramName != 'userData') {
                  params = params.set(
                    paramName,
                    JSON.stringify(loadOptions[paramName])
                  );
                }
              });

            // Add scope parameter to all requests
            params = params.set('scope', this.currentScopeName);

            response = await lastValueFrom(
              this.taskDataService.getAllWithParameters(params)
            );
          }

          // API returns { data: [], totalCount: N } → _.values() → [dataArray, totalCount]
          const responseData = Array.isArray(response[0]) ? response[0] : (response[1]?.data ?? []);
          const responseTotalCount = Array.isArray(response[0]) ? (response[1] ?? 0) : (response[1]?.totalCount ?? 0);

          await this.enrichRowDataAsync(responseData);
          this.ref.detectChanges();

          // When Subtasks with Attachments is active, keep only parent tasks that have
          // at least one subtask assigned to the current logged-in user.
          let taskData: ITaskResponse[] = this.applyRejectionVisibilityToSubTasks(responseData);
          if (this.isSubtasksWithAttachmentsSelected) {
            const currentUserId = localStorage.getItem('loggedInUserId');

            taskData = taskData.reduce((acc: ITaskResponse[], row: ITaskResponse) => {
              if (!Array.isArray(row.subTasks)) return acc;

              if (row.subTasks.some((sub: ITaskResponse) => sub.assignedUserId === currentUserId)) {
                acc.push(row);
              }
              return acc;
            }, []);
          }

          this.isLoading = false;
          this.ref.detectChanges(); // force CD after async load completes outside zone

          return {
            data: taskData,
            totalCount: this.isSubtasksWithAttachmentsSelected ? taskData.length : responseTotalCount,
          };
        } catch (err: any) {
          this.isLoading = false;
          this.ref.detectChanges(); // force CD after async error outside zone
          notify(err.message, 'error', getNotificationTimeout());
          this.loggingService.logError(err, SeverityLevel.Error);

          return {
            data: this.getTestData(),
            totalCount: 0,
          };
        }
      },
    });
  }

  buttonClicked: boolean = false;

  /** Called when the user successfully posts a comment via the chat panel.
   *  Increments commentCount on the matching grid row and repaints it so the
   *  chat icon turns red without waiting for a SignalR taskChanged round-trip. */
  onChatCommentPosted(taskId: string): void {
    if (!taskId || !this.dataGridTasks?.dataGrid?.instance) return;
    const gridInstance = this.dataGridTasks.dataGrid.instance;
    const row = gridInstance.getVisibleRows().find(r => r.data?.id === taskId);
    if (row) {
      row.data.commentCount = (row.data.commentCount || 0) + 1;
      gridInstance.repaintRows([row.rowIndex]);
    }
  }

  onDataGridButtonClick(e: any) {
    // Block the data-grid's 500ms-delayed onRowClick from overriding the
    // section that the button click just set. The flag is reset after 600ms
    // (safely past the 500ms double-click guard in data-grid.component.ts).
    this.buttonClicked = true;
    setTimeout(() => { this.buttonClicked = false; }, 600);

    // console.log(e);
    if (e.event.data.button.id == '1') {
      this.selectedSectionIndex = 1;
      this.isTaskDetailLoadedSubject$.next(false);
      this.selectedRowData.length = 0;
      this.selectedRowData.push(e.event.data.rowData);

      this.openDrawer({ data: e.event.data.rowData });
    } else if (e.event.data.button.id == '3' && e.event.data.rowData?.taskId?.startsWith('POR')) {
      const rowData = e.event.data.rowData;
      if (rowData.id) {
        void this.markTaskLogsAsRead(rowData.id, rowData);
      }

      this.selectedSectionIndex = 3;
      this.isTaskDetailLoadedSubject$.next(false);
      this.selectedRowData.length = 0;
      this.selectedRowData.push(rowData);

      this.openDrawer({ data: rowData });
    } else if (e.event.data.button.id == 2) {
      this.selectedSectionIndex = 2;

      // Mark all URLs as read for this task
      const taskId = e.event.data.rowData.id;
      if (taskId) {
        this.markUrlsAsRead(taskId, e.event.data.rowData);
      }

      const sharePointUrl = buildSharePointTaskUrl(
        this.sharepointRootUrl,
        e.event.data.rowData.taskId
      );
      if (sharePointUrl) {
        window.open(sharePointUrl, '_blank', 'noopener,noreferrer');
      } else {
        this.loggingService.logError(
          new Error('Blocked invalid SharePoint URL for task'),
          SeverityLevel.Warning
        );
      }
    }
  }

  async markUrlsAsRead(taskId: string, rowData: any): Promise<void> {
    try {
      await lastValueFrom(this.taskDataService.markAllUrlsAsReadForTask(taskId));

      // Immediately set unreadUrlCount to 0 on the task object
      if (rowData) {
        rowData.unreadUrlCount = 0;
        // Trigger change detection to update the badge
        this.ref.detectChanges();
      }
    } catch (err: any) {
      this.loggingService.logError(err, SeverityLevel.Error);
      // Silently fail - don't show notification as this is a background operation
    }
  }

  async markTaskLogsAsRead(taskId: string, rowData: any): Promise<void> {
    try {
      await lastValueFrom(this.taskDataService.markAllTaskLogsAsReadForTask(taskId));

      if (rowData) {
        rowData.unreadTaskLogCount = 0;
        const gridInstance = this.dataGridTasks?.dataGrid?.instance;
        const visibleRow = gridInstance?.getVisibleRows()?.find(
          row => row.data?.id === taskId
        );
        if (visibleRow) {
          gridInstance.repaintRows([visibleRow.rowIndex]);
        }
        this.ref.detectChanges();
      }
    } catch (err: any) {
      this.loggingService.logError(err, SeverityLevel.Error);
    }
  }

  isButtonDisabled(id: string, data: any): boolean {
    if (data == null) return true;

    const urls: any[] = Array.isArray(data.urls) ? data.urls : [];
    const commentCount: number = data.commentCount ?? null;

    if (id == '2' && commentCount == null && urls.length == 0) return true;
    if (id == '1' && commentCount == null) return true;
    if (id == '3' && !data.taskId?.startsWith('POR')) return true;

    if (id == '2' && urls.length == 0) {
      //files
      return true;
    }
    return false;
  }

  isButtonVisible(id: string, data: any): boolean {
    return id !== '3' || data?.taskId?.startsWith('POR') === true;
  }

  getButtonHint(button: any, data: any): string {
    if (data == null) return button.text;

    const urls: any[] = Array.isArray(data.urls) ? data.urls : [];

    if (button.id == '2' && urls.length == 1) {
      //files
      return `${urls.length} file attached`;
    } else if (button.id == '2' && urls.length > 1) {
      //files
      return `${urls.length} files attached`;
    } else if (button.id == '1' && data.commentCount == 0) {
      //chat
      return button.text;
    } else if (button.id == '1' && data.commentCount == 1) {
      //chat
      return `${data.commentCount} comment attached`;
    } else if (button.id == '1' && data.commentCount > 1) {
      //chat
      return `${data.commentCount} comments attached`;
    }

    return button.text;
  }

  getButtonClass(button: any, data: any): string {
    return 'dx-chat-button';
  }

  getButtonIcon(button: any, rowData: any): string {
    if (button.id == '1' && (rowData.commentCount == 0 && rowData.unreadCommentCount == 0)) {
      //chat
      return 'assets/images/comment_icon.svg';
    } else if (button.id == '1' && (rowData.commentCount > 0 || rowData.unreadCommentCount > 0)) {
      //chat
      return 'assets/images/new_comments_icon.svg';
    } else if (button.id == '3') {
      //task log
      return 'assets/images/menu_book_icon.svg';
    } else if (
      button.id == '2' &&
      ((rowData.urls == null || rowData.urls.length == 0) ||
      ((rowData.unreadUrlCount == null || rowData.unreadUrlCount.length == 0)))
    ) {
      //files
      return 'assets/images/document_icon.svg';
    } else if (button.id == '2' && (rowData.urls.length > 0 || rowData.unreadUrlCount > 0)) {
      //files
      return 'assets/images/new_document_icon.svg';
    }
    return button.icon;
  }

  getDataGridButtons() {
    const allButtons = [
      { id: '1', name: 'chat', icon: 'comment', text: 'Chat', disabled: true },
      ...(this.featureFlagsService.isEu()
        ? [{ id: '3', name: 'task-log', icon: 'assets/images/menu_book_icon.svg', text: 'Task Log', disabled: true }]
        : []),
      {
        id: '2',
        name: 'files',
        icon: 'file',
        text: 'View Files',
        disabled: false,
      },
      //{ id: "3", name: 'delete', icon: 'trash', text: 'Delete' },
    ];

    // Show buttons when scope is NOT "My Subtasks" (key=0).
    // My Subtasks shows parent tasks, and chat/documents belong to the subtask level.
    // Exception: always show buttons if user navigated to parent via "Go To Parent".
    const currentScopeKey = localStorage.getItem(this.myTasksKey);
    const isMySubtasksScope = (currentScopeKey == '0') && !this.isNavigatedToParent;

    // Set button array: show allButtons for All/MyTeam/SubtasksWithAttachments, hide for MySubtasks
    this.datagridButtons = isMySubtasksScope ? [] : allButtons;

    // Show/hide the buttons column itself (show for All/MyTeam/SubtasksWithAttachments, hide for MySubtasks)
    const buttonsColumn = this.taskColumnData?.find(col => col.cellTemplate === 'buttonsTemplate');
    if (buttonsColumn) {
      buttonsColumn.visible = !isMySubtasksScope;  // true when NOT My Subtasks, false when My Subtasks
    }

    // Hide the Open Subtask column when the scope contains 'subtasks' (e.g. My Subtasks,
    // Subtasks with Attachments, and any future All Subtasks option), since those views
    // show individual subtasks as rows rather than parent tasks.
    const isSubtasksScope = this.currentScopeName.toLowerCase().includes('subtasks');
    const openSubtaskColumn = this.taskColumnData?.find(col => col.field === 'openSubtask');
    if (openSubtaskColumn) {
      openSubtaskColumn.visible = !isSubtasksScope;
    }

    // Force change detection to ensure visibility update is applied
    this.ref.detectChanges();
  }

  private formatTaskDataForSearch(taskData: any): string {
    if (!taskData) return '';

    try {
      // Parse the JSON if it's a string
      const parsedData = typeof taskData === 'string' ? JSON.parse(taskData) : taskData;

      // Get column names for filtering (same logic as in the pipe)
      const columnNames = this.getExistingColumnNames();
      const normalizedColumnNames = columnNames.map(col => col.toLowerCase());

      // Filter out entries similar to the pipe logic
      const entries = Object.entries(parsedData).filter(([key, val]) => {
        // Exclude the 'description' key specifically (same as pipe)
        if (key.toLowerCase() === 'description') {
          return false;
        }

        // Check if key matches existing column names
        const keyLower = key.toLowerCase();
        const keyTitleCase = this.formatKeyForSearch(key).toLowerCase();
        const keySpaced = key.replace(/([A-Z])/g, ' $1').trim().toLowerCase();

        const isMatch = normalizedColumnNames.some(colName =>
          colName === keyLower ||
          colName === keyTitleCase ||
          colName === keySpaced ||
          colName.replace(/\s+/g, '') === keyLower ||
          colName.replace(/\s+/g, '').toLowerCase() === key.toLowerCase()
        );

        return !isMatch;
      });

      // Format entries for searching (simplified version of pipe logic)
      const formattedEntries = entries.map(([key, val]) => {
        const formattedKey = this.formatKeyForSearch(key);
        const formattedValue = this.formatValueForSearch(val);
        return `${formattedKey}: ${formattedValue}`;
      });

      return formattedEntries.join(', ');
    } catch (error) {
      // If parsing fails, return the original value as string
      return String(taskData);
    }
  }

  private formatKeyForSearch(key: string): string {
    // Convert camelCase to Title Case (same as pipe)
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, char => char.toUpperCase())
      .trim();
  }

  private formatValueForSearch(value: any): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'number') return value.toString();
    return String(value);
  }

  getExistingColumnNames(): string[] {
    if (!this.taskColumnData) {
      return [];
    }

    return this.taskColumnData
      .filter(col => col.title || col.field) // Only include columns with names
      .map(col => col.title || col.field || '') // Get the display name or field name
      .filter(name => name && name.trim() !== '') // Remove empty names
      .concat(['Detail', 'Actions', 'Button', 'Edit', 'Delete']); // Add common action column names
  }

  private getBooleanYesNoHeaderFilter() {
    return [
      { text: 'Yes', value: true },
      { text: 'No', value: false },
    ];
  }

  // Wraps DevExtreme's default distinct-value header filter so blank/placeholder creators never appear as options.
  private getCreatedByHeaderFilterDataSource() {
    return (options: any) => {
      const defaultPostProcess = options.dataSource.postProcess;
      options.dataSource.postProcess = (results: any[]) => {
        const processed = defaultPostProcess ? defaultPostProcess(results) : results;
        return (processed || []).filter((item: any) => {
          const value = (item?.value ?? '').toString().trim();
          return value !== '' && value.toLowerCase() !== 'unknown user';
        });
      };
    };
  }

  private getRequestTypeDisplayName(requestType: string | null | undefined): string {
    if (!requestType) {
      return '';
    }

    const trimmed = requestType.trim();

    if (trimmed.toLowerCase() === 'lease consent') {
      return 'REF Lease Consent';
    }

    // Tenancy requests are persisted as their resolved Proda variant (e.g. "Onboarding - Tenancy -
    // Proda Yes"); the grid should always show the base request type the user selected.
    const tenancyVariant = /^((?:aviva\s+)?onboarding\s*-?\s*tenancy)\s*-/i.exec(trimmed);
    if (tenancyVariant) {
      return tenancyVariant[1].trim();
    }

    return trimmed;
  }

setTaskGridColumnData() {
  // EU deployments capture a deal (not a loan) under the same tag, so the column reads differently by region.
  const referenceNameColumnTitle = this.featureFlagsService.isEu() ? 'Deal Name' : 'Reference Name';
  const taskColumns: IGridColumn[] = [
    {
      field: '',
      columnType: 'buttons',
      dataType: '',
      title: '',
      cellTemplate: 'buttonsTemplate',
      visible: true,
      fixed: true,
      fixedPosition: 'left',
      showInColumnChooser: false,
    },
    {
      field: 'taskId',
      dataType: 'string',
      title: 'Task Id',
      allowSearch: true,
      allowFiltering: true,
    },
    {
      field: 'workflow',
      dataType: 'string',
      title: 'Task Type',
      allowSearch: false,
      allowFiltering: true,
    },
    {
      field: 'name',
      dataType: 'string',
      title: 'Request Type',
      valueCalculator: (task: any) => this.getRequestTypeDisplayName(task?.name),
      allowSearch: true,
      allowFiltering: true,
    },
    {
      field: 'openSubtask',
      dataType: 'string',
      title: 'Open Subtask',
      allowSearch: false,
      allowFiltering: false,
      allowSorting: false,
      allowGrouping: false,
      width: 150,
    },
    {
      field: 'dueDate',
      dataType: 'date',
      title: 'Due Date',
      allowSearch: true,
      allowFiltering: false,
      cellTemplate: 'dueDateTemplate',
    },
    {
      field: 'status',
      dataType: 'string',
      title: 'Status',
      allowSearch: false,
      allowFiltering: true,
      cellTemplate: 'statusTemplate',
      width: 160,
      hasCustomFilter: true,
      filterDataSource: {
        load: () => {
          // Only called when the filter dropdown is opened
          return this.taskDataService.getStatuses().toPromise().then((result: any) => {
            // Transform API response to DevExtreme header filter format: { text, value }
            if (result && result[1]) {
              return result[1].map((status: any) => ({
                text: status.name,
                value: status.name
              }));
            }
            return [];
          });
        }
      }
    },
    {
      field: 'assignedUserName',
      dataType: 'string',
      title: 'Assigned To',
      allowSearch: false,
      allowFiltering: true,
      width: 150,
      calculateFilterExpression: (filterValue: any, selectedFilterOperation: string, target: string) => {
        // When filtering by name in header filter, translate to userId for server
        if (target === 'headerFilter') {
          const userIds = this.getUserIdsByName(filterValue);
          return ['assignedUserId', selectedFilterOperation || '=', userIds];
        }
        // For search panel or other cases, keep using name
        return ['assignedUserName', selectedFilterOperation || 'contains', filterValue];
      }
    },
    {
      field: 'referenceName',
      dataType: 'string',
      title: referenceNameColumnTitle,
      allowSearch: true,
      allowFiltering: true,
    },
    {
      field: 'amount',
      dataType: 'number',
      title: 'Amount',
      allowSearch: false,
      allowFiltering: true,
      cellTemplate: 'amountTemplate',
    },
    {
      field: 'taskData',
      dataType: 'string',
      title: 'Detail',
      // Excluded from the client-side search set: DevExtreme's native search-text highlighter
      // can't distinguish JSON property labels from values in this column's rendered HTML, and
      // would incorrectly highlight matches inside labels like "Transaction Type". The backend
      // (TaskRepository.ExtractAndApplySearchFilter) widens into taskData unconditionally once any
      // other allowSearch column forms a valid search group, so this does not affect match results.
      allowSearch: false,
      allowFiltering: true,
      visible: true,
      // Default width keeps long detail text wrapping within the cell instead of auto-expanding the column off-screen.
      width: 350,
      cellTemplate: 'parentTaskDataTemplate',
    },
    {
      field: 'team',
      dataType: 'string',
      title: 'Team',
      allowSearch: false,
      allowFiltering: true,
    },
    {
      field: 'createdOn',
      dataType: 'datetime',
      title: 'Created On',
      allowSearch: false,
      allowFiltering: true,
    },
    {
      field: 'createdBy',
      dataType: 'string',
      title: 'Created By',
      allowSearch: false,
      allowFiltering: true,
      hasCustomFilter: true,
      // Legacy rows can have a blank or 'Unknown user' placeholder creator; hide both from the picker.
      filterDataSource: this.getCreatedByHeaderFilterDataSource(),
    },
    {
      field: 'dateCompleted',
      dataType: 'datetime',
      title: 'Resolved',
      allowSearch: false,
      allowFiltering: true,
      visible: false,
    },
    {
      field: 'description',
      dataType: 'string',
      title: 'Description',
      allowSearch: false,
      allowFiltering: false,
      visible: false,
    },
  ];

  if (this.selectedView === 'Voucher') {
    // For Voucher view, build a custom column order:
    // Buttons, Task ID, Task Type, Request Type, Amount, Due Date, Status, Assigned To,
    // Debit Bank Account, Reference Name, Fees Paid to MS, Billable to Client, Detail, and other columns
    const voucherTaskColumns: IGridColumn[] = [];

    // Add all base columns except the ones we'll reorder
    const columnsToSkip = ['amount', 'referenceName', 'taskData', 'description', 'dueDate'];
    for (const column of taskColumns) {
      if (!columnsToSkip.includes(column.field)) {
        voucherTaskColumns.push(column);
      }
    }

    // Insert Voucher Due Date and Amount where Due Date would normally appear
    const statusIndex = voucherTaskColumns.findIndex((col) => col.field === 'status');
    if (statusIndex >= 0) {
      voucherTaskColumns.splice(statusIndex, 0, {
        field: 'voucherDueDate',
        dataType: 'date',
        title: 'Voucher Due Date',
        allowSearch: false,
        allowFiltering: false,
        cellTemplate: 'dueDateTemplate',
      });
      voucherTaskColumns.splice(statusIndex + 1, 0, {
        field: 'voucherAmount',
        dataType: 'number',
        title: 'Amount',
        allowSearch: false,
        allowFiltering: true,
        cellTemplate: 'amountTemplate',
      });
      voucherTaskColumns.splice(statusIndex + 2, 0, {
        field: 'currency',
        dataType: 'string',
        title: 'Currency',
        allowSearch: true,
        allowFiltering: true,
      });
    }

    // Find Request Type column and insert after it
    const requestTypeIndex = voucherTaskColumns.findIndex((col) => col.title === 'Request Type');
    const insertAfterRequestType = requestTypeIndex >= 0 ? requestTypeIndex + 1 : voucherTaskColumns.length;

    // Insert Voucher-specific columns: Debit Bank Account, Reference Name, Billable to Client, Is Urgent
    voucherTaskColumns.splice(
      insertAfterRequestType,
      0,
      {
        field: 'debitBank',
        dataType: 'string',
        title: 'Debit Bank',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'referenceName',
        dataType: 'string',
        title: referenceNameColumnTitle,
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'paymentMethod',
        dataType: 'string',
        title: 'Payment Method',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'isUrgent',
        dataType: 'boolean',
        title: 'Rush Job',
        allowSearch: false,
        allowFiltering: true,
        cellTemplate: 'isUrgentTemplate',
        hasCustomFilter: true,
        filterDataSource: this.getBooleanYesNoHeaderFilter(),
      }
    );

    // Add Billable to Client and Deal Name just before the Detail column
    voucherTaskColumns.push({
      field: 'billableToClient',
      dataType: 'boolean',
      title: 'Billable to Client',
      allowSearch: false,
      allowFiltering: true,
      cellTemplate: 'booleanYesNoTemplate',
      hasCustomFilter: true,
      filterDataSource: this.getBooleanYesNoHeaderFilter(),
    });

    voucherTaskColumns.push({
      field: 'dealName',
      dataType: 'string',
      title: 'Deal Name',
      allowSearch: true,
      allowFiltering: true,
    });

    // Add Fees Paid to MS just before Detail
    voucherTaskColumns.push({
      field: 'treasuryProvideFedRefNumbers',
      dataType: 'boolean',
      title: 'Provide Fed Ref #(s)',
      allowSearch: false,
      allowFiltering: true,
      cellTemplate: 'booleanYesNoTemplate',
      hasCustomFilter: true,
      filterDataSource: this.getBooleanYesNoHeaderFilter(),
    });

    voucherTaskColumns.push({
      field: 'fedReferenceNumbers',
      dataType: 'string',
      title: 'Fed Ref #',
      allowSearch: true,
      allowFiltering: true,
    });

    voucherTaskColumns.push({
      field: 'feesPaidToMS',
      dataType: 'boolean',
      title: 'Fees Paid to MS',
      allowSearch: false,
      allowFiltering: true,
      cellTemplate: 'booleanYesNoTemplate',
      hasCustomFilter: true,
      filterDataSource: this.getBooleanYesNoHeaderFilter(),
    });

    voucherTaskColumns.push({
      field: 'taskData',
      dataType: 'string',
      title: 'Detail',
      // See allowSearch comment on the base taskData column definition above.
      allowSearch: false,
      allowFiltering: true,
      width: 350,
      cellTemplate: 'parentTaskDataTemplate',
    });

    // Clear taskColumns and replace with voucherTaskColumns
    taskColumns.length = 0;
    taskColumns.push(...voucherTaskColumns);
  }

  if (this.selectedView === 'F&C') {
    // For F&C view, build a custom column order with finance-specific fields
    const financialComplianceTaskColumns: IGridColumn[] = [
      {
        field: '',
        columnType: 'buttons',
        dataType: '',
        title: '',
        cellTemplate: 'buttonsTemplate',
        visible: true,
        fixed: true,
        fixedPosition: 'left',
        showInColumnChooser: false,
      },
      {
        field: 'taskId',
        dataType: 'string',
        title: 'Task Id',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'name',
        dataType: 'string',
        title: 'Request Type',
        valueCalculator: (task: any) => this.getRequestTypeDisplayName(task?.name),
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'borrowerContact',
        dataType: 'string',
        title: 'Borrower Contact',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'borrowerName',
        dataType: 'string',
        title: 'Borrower Name',
        allowSearch: true,
        allowFiltering: true,
        width: 300,
        cellTemplate: 'truncatedTextTemplate',
      },
      {
        field: 'category',
        dataType: 'string',
        title: 'Category',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'daysPastDue',
        dataType: 'number',
        title: 'Days Past Due',
        allowSearch: false,
        allowFiltering: true,
      },
      {
        field: 'dealId',
        dataType: 'string',
        title: 'Deal ID #',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'dealName',
        dataType: 'string',
        title: 'Deal Name',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'due',
        dataType: 'string',
        title: 'Due',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'dueDate',
        dataType: 'date',
        title: 'Due Date',
        allowSearch: true,
        allowFiltering: false,
        cellTemplate: 'dueDateTemplate',
      },
      {
        field: 'entityName',
        dataType: 'string',
        title: 'Entity Name',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'fa',
        dataType: 'string',
        title: 'FA',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'format',
        dataType: 'string',
        title: 'Format',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'frequency',
        dataType: 'string',
        title: 'Frequency',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'loanNumber',
        dataType: 'string',
        title: 'Loan Number',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'maturityDate',
        dataType: 'date',
        title: 'Maturity Date',
        allowSearch: false,
        allowFiltering: false,
      },
      {
        field: 'msAm',
        dataType: 'string',
        title: 'MS AM',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'msComments',
        dataType: 'string',
        title: 'MS Comments',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'msDateReceived',
        dataType: 'date',
        title: 'MS Date Received',
        allowSearch: false,
        allowFiltering: false,
      },
      {
        field: 'msDateRequested',
        dataType: 'date',
        title: 'MS Date Requested',
        allowSearch: false,
        allowFiltering: false,
      },
      {
        field: 'msRequestToBorrower',
        dataType: 'string',
        title: 'MS Request to Borrower',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'notes',
        dataType: 'string',
        title: 'Notes',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'periodDue',
        dataType: 'string',
        title: 'Period Due',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'propertyType',
        dataType: 'string',
        title: 'Property Type',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'reference',
        dataType: 'string',
        title: 'Reference',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'reportEntity',
        dataType: 'string',
        title: 'Report Entity',
        allowSearch: true,
        allowFiltering: true,
      },
      {
        field: 'status',
        dataType: 'string',
        title: 'Status',
        allowSearch: false,
        allowFiltering: true,
        cellTemplate: 'statusTemplate',
        hasCustomFilter: true,
        filterDataSource: {
          load: () => {
            return this.taskDataService.getStatuses().toPromise().then((result: any) => {
              if (result && result[1]) {
                return result[1].map((status: any) => ({
                  text: status.name,
                  value: status.name
                }));
              }
              return [];
            });
          }
        }
      },
      {
        field: 'assignedUserName',
        dataType: 'string',
        title: 'Assigned To',
        allowSearch: false,
        allowFiltering: true,
        calculateFilterExpression: (filterValue: any, selectedFilterOperation: string, target: string) => {
          if (target === 'headerFilter') {
            const userIds = this.getUserIdsByName(filterValue);
            return ['assignedUserId', selectedFilterOperation || '=', userIds];
          }
          return ['assignedUserName', selectedFilterOperation || 'contains', filterValue];
        }
      },
      {
        field: 'amount',
        dataType: 'number',
        title: 'Amount',
        allowSearch: false,
        allowFiltering: true,
        cellTemplate: 'amountTemplate',
      },
      {
        field: 'taskData',
        dataType: 'string',
        title: 'Detail',
        // See allowSearch comment on the base taskData column definition above.
        allowSearch: false,
        allowFiltering: true,
        visible: true,
        width: 350,
        cellTemplate: 'parentTaskDataTemplate',
      },
    ];

    // Clear taskColumns and replace with financialComplianceTaskColumns
    taskColumns.length = 0;
    taskColumns.push(...financialComplianceTaskColumns);
  }

  this.taskColumnData = taskColumns;

  const subTaskColumns: IGridColumn[] = [
    {
      field: 'taskId',
      dataType: 'string',
      title: 'Task Id',
      allowSearch: false,
      allowFiltering: false,
    },
    {
      field: 'name',
      dataType: 'string',
      title: 'Task Name',
      allowSearch: false,
      allowFiltering: false,
    },
    {
      field: 'dueDate',
      dataType: 'date',
      title: 'Due Date',
      allowSearch: false,
      allowFiltering: false,
      cellTemplate: 'dueDateTemplate',
    },
    {
      field: 'status',
      dataType: 'string',
      title: 'Status',
      allowSearch: false,
      allowFiltering: false,
      cellTemplate: 'statusTemplate',
    },
    {
      field: 'assignedUserName',
      dataType: 'string',
      title: 'Assigned To',
      allowSearch: false,
      allowFiltering: false,
    },
    {
      field: 'team',
      dataType: 'string',
      title: 'Team',
      allowSearch: false,
      allowFiltering: false,
    },
    {
      field: 'dateCompleted',
      dataType: 'datetime',
      title: 'Resolved',
      allowSearch: false,
      allowFiltering: false,
    },
    {
      field: 'description',
      dataType: 'string',
      title: 'Description',
      allowSearch: false,
      allowFiltering: false,
      visible: false,
    },
  ];

  if (this.selectedView === 'Voucher') {
    // For Voucher detail grid, follow the same column order as main grid
    const voucherSubTaskColumns: IGridColumn[] = [];

    // Add all base columns except the ones we'll reorder
    const columnsToSkip = ['dueDate'];
    for (const column of subTaskColumns) {
      if (!columnsToSkip.includes(column.field)) {
        voucherSubTaskColumns.push(column);
      }
    }

    // Find Status column and insert after it
    const statusIndex = voucherSubTaskColumns.findIndex((col) => col.field === 'status');
    const insertAfterStatus = statusIndex >= 0 ? statusIndex + 1 : voucherSubTaskColumns.length;

    // Insert Voucher-specific columns for subtask detail grid
    voucherSubTaskColumns.splice(
      insertAfterStatus,
      0,
      {
        field: 'debitBank',
        dataType: 'string',
        title: 'Debit Bank',
        allowSearch: false,
        allowFiltering: false,
      },
      {
        field: 'feesPaidToMS',
        dataType: 'boolean',
        title: 'Fees Paid to MS',
        allowSearch: false,
        allowFiltering: false,
        cellTemplate: 'booleanYesNoTemplate',
      },
      {
        field: 'billableToClient',
        dataType: 'boolean',
        title: 'Billable to Client',
        allowSearch: false,
        allowFiltering: false,
        cellTemplate: 'booleanYesNoTemplate',
      },
      {
        field: 'isUrgent',
        dataType: 'boolean',
        title: 'Rush Job',
        allowSearch: false,
        allowFiltering: false,
        cellTemplate: 'isUrgentTemplate',
      }
    );

    // Insert Voucher Due Date where Due Date would normally appear
    const subTaskStatusIndex = voucherSubTaskColumns.findIndex((col) => col.field === 'status');
    if (subTaskStatusIndex >= 0) {
      voucherSubTaskColumns.splice(subTaskStatusIndex, 0, {
        field: 'voucherDueDate',
        dataType: 'date',
        title: 'Voucher Due Date',
        allowSearch: false,
        allowFiltering: false,
        cellTemplate: 'dueDateTemplate',
      });
    }

    // Clear subTaskColumns and replace with voucherSubTaskColumns
    subTaskColumns.length = 0;
    subTaskColumns.push(...voucherSubTaskColumns);
  }

  this.subTaskColumnData = subTaskColumns;
}

  ngOnInit(): void {
    this.isDrawerOpen = false;
    this.addNewText = 'add new task';
    this.selectedView = this.normalizeSelectedView(
      localStorage.getItem(this.selectedViewKey)
    );
    this.applySelectedView();
    this.getDataGridButtons();

    this.initializeFilterState();
    this.storageKey = 'Tasks_View';
    this.getTaskFromLink();

    // Trigger statuses retrieval and subscribe to hold status updates throughout the session
    this.taskDataService.retrieveStatuses();
    this.taskDataService.getHoldStatusNames()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        skipWhile(() => !this.taskDataService.isStatusesLoaded)
      )
      .subscribe(holdStatuses => {
        const nextHoldStatusNames = holdStatuses || [];
        const holdStatusesChanged =
          JSON.stringify(this.holdStatusNames) !== JSON.stringify(nextHoldStatusNames);

        this.holdStatusNames = nextHoldStatusNames;

        // Rebuild hold-related quick filters once hold statuses are available.
        this.showRejectedChanged({ value: this.showRejected }, false);

        // Load task data only on first population of hold statuses
        if (!this.isTaskDataLoaded) {
          this.isTaskDataLoaded = true;
          this.LoadTaskData();
          return;
        }

        // If hold statuses change after initial load, refresh to keep results in sync.
        if (holdStatusesChanged) {
          this.reloadGridPreservingState();
        }
      });
  }


  getTaskFromLink() {
    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (params) => {
      let taskId = params['taskId'];
      let section = params['section'];
      if (taskId != null) {
        try {
          this.isTaskDetailLoadedSubject$.next(true);
          const data = await lastValueFrom(
            this.taskDataService.getTaskById(taskId)
          );
          let task = data[1];

          // Notification linked to a subtask: filter the grid to its parent while the drawer still shows the subtask.
          if (task.parentId) {
            const parent = await this.applyParentTaskFilter(task.parentId);
            if (parent) {
              setTimeout(() => {
                this.dataGridTasks.dataGrid.instance.expandRow(parent.parentRowId);
              }, 0);
            }
          }

          this.selectedRowData.length = 0;
          this.selectedRowData.push(task);
          let e: any = {};
          e.data = task;
          this.selectedSectionIndex = section === 'chat' ? 1 : section === 'tasklog' ? 3 : 0;
          this.openDrawer(e);
        } catch (error: any) {
          this.isTaskDetailLoadedSubject$.next(false);
          notify(error.message, 'error', getNotificationTimeout());
          this.loggingService.logError(error, SeverityLevel.Error);
        }
      }
    });
  }

  reloadPage() {
    // console.log('reloadPage');
    // console.log(this.router.url);
    this.router.navigate([this.router.url], {
      skipLocationChange: true,
      state: null,
    });
  }

  onExternalFilterDismissed() {
    this.taskNavigationFilterParameters = null;
    this.filteredByDashboardTaskIds = false;
    this.showSearchPanel = true;
    this.isNavigatedToParent = false;
    this.getDataGridButtons();

    this.dataGridTasks.getDataSource()?.reload();
  }

  initializeFilterState(): void {
    // Check if this is the first load of the session (no filters in localStorage)
    const hasExistingDueFilter = localStorage.getItem(this.dateRangeKey);
    const hasExistingScopeFilter = localStorage.getItem(this.myTasksKey);
    const hasExistingShowCompleted = localStorage.getItem('showCompleted');
    const hasExistingShowRejected = localStorage.getItem('showRejected');

    // Only set defaults if no existing filter state
    if (!hasExistingDueFilter) {
      // Set Due radiogroup to default (Today)
      const dueOptions = datePanelItems.find(opt => opt.name === 'Due');
      const todayItem = dueOptions?.items.find(item => item.text === 'Today');
      if (todayItem) {
        localStorage.setItem(this.dateRangeKey, todayItem.key.toString());
      }
    }

    if (!hasExistingScopeFilter) {
      // Set Scope radiogroup to default (My Subtasks)
      const scopeOptions = datePanelItems.find(opt => opt.name === 'Scope');
      const mySubtasksItem = scopeOptions?.items.find(item => item.text === 'My Subtasks');
      if (mySubtasksItem) {
        localStorage.setItem(this.myTasksKey, mySubtasksItem.key.toString());
      }
    }

    // Always reset showCompleted and showRejected to false on init so a previous
    // session's stale localStorage values cannot carry over to a new login.
    localStorage.setItem('showCompleted', 'false');
    localStorage.setItem('showRejected', 'false');

    // Now load from localStorage (either defaults just set, or user's previous selection)
    const dueKey = localStorage.getItem(this.dateRangeKey) || '4'; // Default to Today (key 4)
    const scopeKey = localStorage.getItem(this.myTasksKey) || '0'; // Default to My Subtasks (key 0)
    const showCompleted = JSON.parse(localStorage.getItem('showCompleted') || 'false');
    const showRejected = JSON.parse(localStorage.getItem('showRejected') || 'false');

    // Set checkbox values
    this.showCompleted = showCompleted;
    this.showRejected = showRejected;

    // Update radioGroupValue
    this.radioGroupValue = { Due: null, Scope: null };

    // Set Due radiogroup from localStorage
    const dueOptions = datePanelItems.find(opt => opt.name === 'Due');
    const selectedDueItem = dueOptions?.items.find(item => item.key.toString() === dueKey);
    if (selectedDueItem) {
      this.radioGroupValue['Due'] = selectedDueItem;
      this.selectedDateRange = selectedDueItem;
      this.updateFilterStateForDue(selectedDueItem);
    }

    // Set Scope radiogroup from localStorage
    const scopeOptions = datePanelItems.find(opt => opt.name === 'Scope');
    const selectedScopeItem = scopeOptions?.items.find(item => item.key.toString() === scopeKey);
    if (selectedScopeItem) {
      this.radioGroupValue['Scope'] = selectedScopeItem;
      this.isSubtasksWithAttachmentsSelected = (selectedScopeItem.key === 3);
      this.updateFilterStateForScope(selectedScopeItem);
    }

    // Update gridFilterOptions to match current state
    this.gridFilterOptions = datePanelItems.map(option => {
      if (option.name === 'Due' && selectedDueItem) {
        return {
          ...option,
          selectedItem: selectedDueItem.text
        };
      } else if (option.name === 'Scope' && selectedScopeItem) {
        return {
          ...option,
          selectedItem: selectedScopeItem.text
        };
      }
      return option;
    });

    // Apply filters to the data grid
    this.showCompletedSubject$.next(this.showCompleted);
    this.showRejectedSubject$.next(this.showRejected);

    // Apply the filters without reloading (since we're initializing)
    this.showCompletedChanged({ value: this.showCompleted }, false);
    this.showRejectedChanged({ value: this.showRejected }, false);

    if (this.selectedDateRange) {
      this.buildDateFilter(this.selectedDateRange);
    }

    // Apply scope filter
    if (selectedScopeItem) {
      this.onMyTasksChanged(selectedScopeItem.key, false);
    }
  }

  updateFilterStateForDue(selectedDateItem: DatePanelItem): void {
    // Update the Due filter option in the FilterStateService
    const currentState = this.filterStateService.getCurrentFilterState();
    const updatedFilterOptions = currentState.filterOptions.map((option) => {
      if (option.name === 'Due') {
        return {
          ...option,
          selectedItem: selectedDateItem.text,
        };
      }
      return option;
    });
    this.filterStateService.updateFilterOptions(updatedFilterOptions);
  }

  updateFilterStateForScope(selectedScopeItem: DatePanelItem): void {
    // Update the Scope filter option in the FilterStateService
    const currentState = this.filterStateService.getCurrentFilterState();
    const updatedFilterOptions = currentState.filterOptions.map((option) => {
      if (option.name === 'Scope') {
        return {
          ...option,
          selectedItem: selectedScopeItem.text,
        };
      }
      return option;
    });
    this.filterStateService.updateFilterOptions(updatedFilterOptions);
  }

  // Check if a task is overdue based on due date and completion status
  public isTaskOverdue(task: any): boolean {
    if (!task.dueDate) {
      return false; // No due date means not overdue
    }

    const dueDate = new Date(task.dueDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of day for comparison
    dueDate.setHours(0, 0, 0, 0); // Set to start of day for comparison

    // If task is not overdue (due date is today or in the future), return false
    if (dueDate >= today) {
      return false;
    }

    // Task is past due date, but check if it was completed on time
    // First check if task is completed by status
    const isCompleted = task.status === 'Closed' || task.status === 'Completed';

    if (isCompleted && task.dateCompleted) {
      const completedDate = new Date(task.dateCompleted);
      completedDate.setHours(0, 0, 0, 0); // Set to start of day for comparison

      // If completed date is not later than due date, don't highlight as overdue
      if (completedDate <= dueDate) {
        return false;
      }
    } else if (isCompleted && !task.dateCompleted) {
      // If task is marked as completed but has no completion date, assume it was completed on time
      // This handles cases where the status is updated but dateCompleted field is not populated
      return false;
    }

    // Task is overdue (past due date and either not completed or completed late)
    return true;
  }

  // Auto-expand parent rows that have subtasks when Subtasks with Attachments filter is active
  onGridContentReady(e: any): void {
    if (this.isApplyingGridContentReady) {
      return;
    }

    this.isApplyingGridContentReady = true;
    const gridInstance = e.component;

    try {
      // Enforce buttons column visibility based on current scope.
      // Exception: when the user navigated here via "Go To Parent", keep buttons visible.
      // Column position is now handled declaratively via fixed+fixedPosition in the column definition.
      const columnCount = gridInstance.columnCount();
      let buttonsColumnIndex = -1;
      for (let i = 0; i < columnCount; i++) {
        if (gridInstance.columnOption(i, 'cellTemplate') === 'buttonsTemplate') {
          buttonsColumnIndex = i;
          break;
        }
      }

      const currentScopeKey = localStorage.getItem(this.myTasksKey);
      const isMySubtasksScope = (currentScopeKey == '0') && !this.isNavigatedToParent;

      if (buttonsColumnIndex >= 0) {
        const expectedButtonsVisibility = !isMySubtasksScope;
        const currentButtonsVisibility = gridInstance.columnOption(buttonsColumnIndex, 'visible');
        if (currentButtonsVisibility !== expectedButtonsVisibility) {
          gridInstance.columnOption(buttonsColumnIndex, 'visible', expectedButtonsVisibility);
        }
      }

      // Enforce Open Subtask column visibility: hide for any subtask-based scope
      const isSubtasksScope = this.currentScopeName.toLowerCase().includes('subtasks');
      for (let i = 0; i < columnCount; i++) {
        if (gridInstance.columnOption(i, 'dataField') === 'openSubtask') {
          const expectedOpenSubtaskVisibility = !isSubtasksScope;
          const currentOpenSubtaskVisibility = gridInstance.columnOption(i, 'visible');
          if (currentOpenSubtaskVisibility !== expectedOpenSubtaskVisibility) {
            gridInstance.columnOption(i, 'visible', expectedOpenSubtaskVisibility);
          }
          break;
        }
      }

      if (this.needsAutoExpand && this.isSubtasksWithAttachmentsSelected) {
        this.needsAutoExpand = false;
        setTimeout(() => {
          const visibleRows = gridInstance.getVisibleRows();
          visibleRows.forEach((row: any) => {
            if (row.rowType === 'data' && row.data?.subTasks?.length > 0 && !gridInstance.isRowExpanded(row.key)) {
              gridInstance.expandRow(row.key);
            }
          });
        });
      }
    } finally {
      this.isApplyingGridContentReady = false;
    }
  }

  // Handle cell prepared event to apply overdue styling
  onCellPrepared(e: DxDataGridTypes.CellPreparedEvent): void {
    if (e.rowType === 'data' && e.column?.dataField === 'dueDate') {
      if (this.isTaskOverdue(e.data) || this.isUrgentPrimaryServicingPaymentInstruction(e.data)) {
        e.cellElement.classList.add('overdue-task');
      }
    }

    // Add tooltip for Open Subtask column so overflowing text is fully readable on hover
    if (e.rowType === 'data' && e.column?.dataField === 'openSubtask' && e.data?.openSubtask) {
      e.cellElement.setAttribute('title', e.data.openSubtask);
    }
  }

  // Add this method to the TasksComponent class
  private cleanTaskDataForApi(task: any): any {
    // Create a clean copy without circular references
    const cleanTask = { ...task };

    // Remove properties that create circular references
    delete cleanTask.masterDetails;

    // If it has subTasks, clean them too
    if (cleanTask.subTasks && Array.isArray(cleanTask.subTasks)) {
      cleanTask.subTasks = cleanTask.subTasks.map((subTask) =>
        this.cleanTaskDataForApi(subTask)
      );
    }

    return cleanTask;
  }
}
